import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  uz: {
    translation: {
    common: {
      language: 'Til',
      uzbek: 'Oʻzbekcha',
      russian: 'Ruscha',
      english: 'Inglizcha',
      required: 'Majburiy',
      cancel: 'Bekor qilish',
      save: 'Saqlash',
      confirm: 'Tasdiqlash',
      add: 'Qoʻshish',
      edit: 'Tahrirlash',
      delete: 'Oʻchirish',
      errorGeneric: 'Xatolik yuz berdi',
      retry: 'Qayta urinish',
      loading: 'Yuklanmoqda…',
      noData: 'Maʼlumot yoʻq',
      noAccessTitle: 'Ruxsat yoʻq',
      noAccessDescription: 'Bu boʻlim uchun sizda yetarli ruxsat yoʻq.',
    },
    ui: {
      nothingFound: 'Hech narsa topilmadi',
      searchPlaceholder: 'Qidirish…',
      prevPage: 'Oldingi sahifa',
      nextPage: 'Keyingi sahifa',
      close: 'Yopish',
      menu: 'Menyu',
      back: 'Orqaga',
    },
    errorBoundary: {
      title: 'Kutilmagan xatolik',
      description: 'Iltimos qaytadan urinib koʻring. Muammo davom etsa bosh sahifaga qayting.',
      retry: 'Qayta urinish',
      goHome: 'Bosh sahifaga qaytish',
    },
    dashboard: {
      title: 'Statistika',
      subtitle: 'Tizimga umumiy nazar',
      errorLoad: 'Statistikani yuklab boʻlmadi',
      stats: {
        totalParcels: 'Jami posilkalar',
        pending: 'Moderatsiyada',
        approved: 'Tasdiqlandi',
        rejected: 'Rad etildi',
        parties: 'Partiyalar',
        clients: 'Mijozlar',
      },
      chart: {
        monthlyTitle: 'Oylar boʻyicha posilkalar',
        monthlySubtitle: 'Soʻnggi 6 oydagi yangi posilkalar soni',
        partiesTitle: 'Partiya statuslari',
        partiesSubtitle: 'Hozirgi partiyalarning taqsimlanishi',
      },
    },
    regions: {
      TASHKENT_CITY: 'Toshkent shahri',
      TASHKENT: 'Toshkent viloyati',
      FERGANA: 'Fargʻona',
      ANDIJAN: 'Andijon',
      NAMANGAN: 'Namangan',
      SAMARKAND: 'Samarqand',
      BUKHARA: 'Buxoro',
      SIRDARYA: 'Sirdaryo',
      SURKHANDARYA: 'Surxondaryo',
      NAVOI: 'Navoiy',
      QASHQADARYA: 'Qashqadaryo',
      KHOREZM: 'Xorazm',
      JIZZAKH: 'Jizzax',
      KARAKALPAKSTAN: 'Qoraqalpogʻiston',
      XIVA: 'Xiva',
    },
    notFound: {
      title: 'Sahifa topilmadi',
      description: 'Siz qidirayotgan sahifa mavjud emas yoki olib tashlangan.',
      goHome: 'Bosh sahifaga',
    },
    login: {
      title: 'Tizimga kirish',
      username: 'Username',
      password: 'Parol',
      submit: 'Kirish',
      toastWelcome: 'Xush kelibsiz!',
      errors: {
        usernameRequired: 'Username majburiy',
        passwordRequired: 'Parol majburiy',
        tooLong: 'Juda uzun',
        invalidCredentials: 'Username yoki parol notoʻgʻri',
        generic: 'Tizimga kirishda xatolik',
      },
    },
    topbar: {
      user: {
        fallback: 'Foydalanuvchi',
        owner: 'Egasi',
      },
      menu: {
        logout: 'Chiqish',
      },
      toast: {
        signedOut: 'Tizimdan chiqildi',
      },
    },
    header: {
      user: 'Foydalanuvchi',
      superLabel: 'Super xodim',
    },
    nav: {
      dashboard: 'Statistika',
      parcels: 'Posilkalar',
      parties: 'Partiyalar',
      packages: 'Paketlar',
      splits: 'Boʻlishlar',
      cargoIds: 'Cargo ID',
      warehouse: 'Omborxona',
      categories: 'Kategoriyalar',
      staff: 'Xodimlar',
      roles: 'Rollar',
      clients: 'Mijozlar',
      legacyClients: 'Eski mijozlar',
      support: 'Qoʻllab-quvvatlash',
      supportStaff: 'Texnik yordamchi',
      broadcast: 'Eʼlon yuborish',
      faqs: 'Savol-javoblar',
      limitConfig: 'Limit sozlamasi',
      pricing: 'Narxlar',
      unreadTooltip: '{{count}} ta oʻqilmagan xabar',
      splitsPendingTooltip: '{{count}} ta qoralama boʻlish',
      reportsPhoto: 'Rasm hisobot',
      reportsVideo: 'Video hisobot',
      reportsPhotoPendingTooltip: '{{count}} ta kutilayotgan rasm soʻrovi',
      reportsVideoPendingTooltip: '{{count}} ta kutilayotgan video soʻrovi',
      reportsProverka: 'Tekshiruv',
      reportsProverkaPendingTooltip: '{{count}} ta kutilayotgan tekshiruv soʻrovi',
      returns: 'Vozvratlar',
      returnsPendingTooltip: '{{count}} ta kutilayotgan vozvrat',
    },
    userStatus: {
      ghost: 'Mehmon',
      user: 'Foydalanuvchi',
      admin: 'Admin',
    },
    legacyClients: {
      list: {
        title: 'Eski mijozlar',
        subtitle: 'Eski tizimdan koʻchirilgan mijozlar',
        searchPlaceholder: 'Ism, telefon, Cargo ID yoki username boʻyicha qidirish',
        emptyTitle: 'Eski mijoz topilmadi',
        emptyDescription: 'Qidiruv shartlarini oʻzgartiring.',
        loadError: 'Eski mijozlarni yuklab boʻlmadi',
        columns: {
          cargoIdCode: 'Cargo ID',
          fullName: 'Toʻliq ism',
          phone: 'Telefon',
          username: 'Username',
          telegramName: 'Telegram nomi',
          formCount: 'Anketalar',
          userStatus: 'Holat',
          createdAt: 'Yaratilgan',
        },
      },
    },
    roles: {
      OWNER: 'Super Admin',
      JAPAN_WORKER: 'Yaponiya xodimi',
      UZBEK_WORKER: 'Oʻzbekiston xodimi',
      list: {
        title: 'Rollar',
        subtitle: 'Foydalanuvchi rollarini va ruxsatlarni boshqaring',
        newRole: 'Yangi rol',
        loadError: 'Rollarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha rol yoʻq',
        superBadge: 'Super',
        customBadge: 'Maxsus',
        columns: {
          name: 'Nomi',
          kind: 'Turi',
          permissions: 'Ruxsatlar',
          staffCount: 'Xodimlar',
          createdAt: 'Yaratilgan',
          actions: 'Amallar',
        },
      },
      create: {
        title: 'Yangi rol',
        description: 'Rolga nom bering va kerakli ruxsatlarni belgilang.',
        submit: 'Yaratish',
      },
      edit: {
        title: 'Rolni tahrirlash',
        superTitle: 'Super rolni koʻrish',
        description: 'Rol nomi va ruxsatlarini yangilang.',
        submit: 'Saqlash',
      },
      formPage: {
        createTitle: 'Yangi rol',
        editTitle: 'Rolni tahrirlash',
        notFound: 'Rol topilmadi.',
        loadError: 'Rolni yuklab boʻlmadi',
      },
      delete: {
        title: 'Rolni oʻchirish',
        description: '"{{name}}" rolini oʻchirmoqchimisiz? Avval barcha xodimlarni boshqa rolga koʻchirib oling.',
        reassignLabel: 'Xodimlarni koʻchirish uchun rol',
        reassignHint: 'Bu roldagi barcha xodimlar tanlangan rolga koʻchiriladi, soʻng rol oʻchiriladi.',
        staffWarning: 'Bu rolda {{count}} ta xodim bor. Hammasi koʻchiriladi.',
        noTargets: 'Boshqa rol topilmadi. Avval yangi rol yarating.',
        confirm: 'Oʻchirish',
      },
      form: {
        fields: {
          name: 'Rol nomi',
          permissions: 'Ruxsatlar',
        },
        errors: {
          nameRequired: 'Rol nomi majburiy',
          tooLong: 'Juda uzun',
        },
      },
      treePicker: {
        selectAll: 'Hammasini tanlash',
        selectedCount: 'Tanlangan: {{count}} / {{total}}',
        loadError: 'Ruxsatlar roʻyxatini yuklab boʻlmadi',
        nodes: {
          dashboard: 'Statistika',
          parcels: 'Posilkalar',
          cargo_ids: 'Cargo ID',
          parties: 'Partiyalar',
          warehouse: 'Omborxona',
          clients: 'Mijozlar',
          staff: 'Xodimlar',
          roles: 'Rollar',
          categories: 'Kategoriyalar',
          faqs: 'Savol-javoblar',
          broadcast: 'Eʼlon',
          support: 'Qoʻllab-quvvatlash',
          view: 'Koʻrish',
          list: 'Roʻyxat',
          detail: 'Tafsilotlar',
          create: 'Yaratish',
          update: 'Tahrirlash',
          edit: 'Tahrirlash',
          delete: 'Oʻchirish',
          column: 'Ustun',
          filter: 'Filter',
          approve: 'Tasdiqlash',
          reject: 'Rad etish',
          export: 'Eksport',
          manage: 'Boshqarish',
          scan: 'Skanerlash',
          block: 'Bloklash',
          unblock: 'Blokdan ochish',
          respond: 'Javob berish',
          send: 'Yuborish',
          revert_shipping: 'Joʻnatishni bekor qilish',
          change_status: 'Holatni oʻzgartirish',
          add_packages: 'Posilka qoʻshish',
          claimed_trek_ids: 'Egalik qiladigan Trek ID lar',
          search: 'Qidiruv',
          status: 'Holat',
          cargo_id: 'Cargo ID',
          trek_id: 'Trek ID',
          name: 'Nomi',
          cargo_id_code: 'Cargo ID kodi',
          fulfillment_status: 'Joʻnatish holati',
          region: 'Viloyat',
          created_at: 'Yaratilgan vaqti',
          splits: 'Boʻlishlar',
          distribute: 'Taqsimlash/Saqlash',
          support_staff: 'Texnik yordamchi',
          mark_delivered: 'Mijozga yetkazildi belgilash',
          arrived_packages: 'Yetib kelgan paketlar',
          arrived_parcels: 'Yetib kelgan posilkalar',
        },
      },
      superNotice: 'Bu rol barcha ruxsatlarga ega. Tahrirlab boʻlmaydi.',
      toast: {
        created: 'Rol yaratildi',
        updated: 'Rol yangilandi',
        deleted: 'Rol oʻchirildi',
      },
    },
    parcelStatus: {
      DRAFT: 'Qoralama',
      PENDING: 'Moderatsiyada',
      APPROVED: 'Tasdiqlandi',
      REJECTED: 'Rad etildi',
    },
    fulfillmentStatus: {
      IN_PROGRESS: 'Kutilmoqda',
      SORTING: 'Omborda',
      COLLECTING: 'Qadoqlashda',
      SHIPPING: 'Joʻnatilmoqda',
      ON_THE_WAY: 'Yoʻlda',
      ON_CUSTOMS: 'Bojxonada',
      LOCAL_ON_THE_WAY: 'Omborga keldi',
      SHIPMENT_ON_CUSTOMERS: 'Topshirildi',
      // Kept as compat fallbacks so old payloads still render a label.
      WAITING: 'Kutilmoqda',
      CONFIRMED: 'Tasdiqlangan',
      PACKAGED: 'Upakovlangan',
    },
    warehouseStatus: {
      UNCLAIMED: 'Faol',
      LINKED: 'Nofaol',
    },
    partyStatus: {
      COLLECTING: 'Qadoqlashda',
      SHIPPING: 'Joʻnatilmoqda',
      ON_THE_WAY: 'Yoʻlda',
      ON_CUSTOMS: 'Bojxonada',
      LOCAL_ON_THE_WAY: 'Omborga keldi',
      SHIPMENT_ON_CUSTOMERS: 'Topshirildi',
    },
    cargoIdType: {
      PHYSICAL: 'Jismoniy',
      LEGAL: 'Yuridik',
    },
    cargoIds: {
      list: {
        title: 'Cargo ID',
        subtitle: 'Cargo ID-larni boshqaring',
        searchPlaceholder: 'Kod, ism yoki telefon boʻyicha qidirish',
        loadError: 'Cargo ID-larni yuklab boʻlmadi',
        emptyTitle: 'Cargo ID topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring.',
        columns: {
          code: 'Kod',
          type: 'Turi',
          fullName: 'Ism Sharif',
          parcelsCount: 'Posilkalar soni',
          phone: 'Telefon',
          createdAt: 'Yaratilgan',
          debt: 'Qarzdorlik',
          actions: 'Amallar',
        },
        actions: {
          view: 'Koʻrish',
        },
      },
      detail: {
        subtitle: 'Cargo ID tafsilotlari',
        notFound: 'Cargo ID topilmadi',
        noCode: 'Kod tayinlanmagan',
        empty: 'Maʼlumot yoʻq',
        fields: {
          fullName: 'Ism Sharif',
          phone: 'Telefon',
          region: 'Viloyat',
          type: 'Turi',
          createdAt: 'Yaratilgan',
        },
        owner: {
          title: 'Egasi',
          fullName: 'Ism Sharif',
          phone: 'Telefon',
          passport: 'Pasport',
          pinfl: 'PINFL',
          openClient: 'Mijoz sahifasini ochish',
          empty: 'Egasi biriktirilmagan',
        },
        parcels: {
          title: 'Posilkalar',
          loadError: 'Posilkalarni yuklab boʻlmadi',
          emptyTitle: 'Posilka yoʻq',
          view: 'Koʻrish',
          columns: {
            name: 'Nomi',
            trekId: 'Trek ID',
            status: 'Status',
            total: 'Jami',
            createdAt: 'Sana',
            actions: 'Amallar',
          },
        },
        charges: {
          title: 'Qarzdorlik',
          statusPaid: 'Toʻlangan',
          statusUnpaid: 'Toʻlanmagan',
          statusFree: 'Bepul',
          markPaid: 'Toʻlandi',
          markUnpaid: 'Toʻlanmadi',
          markPaidTitle: 'Toʻlovni tasdiqlash',
          markPaidDescription: '«{{type}}» — {{amount}} toʻlovini toʻlangan deb belgilaysizmi?',
          markPaidConfirm: 'Ha, toʻlandi',
          markPaidToast: 'Toʻlov toʻlangan deb belgilandi',
          markUnpaidToast: 'Toʻlov bekor qilindi',
          paidSuccessTitle: 'Muvaffaqiyatli toʻlandi',
          paidSuccessBody: 'Toʻlov qabul qilindi va chek yaratildi.',
          viewReceipt: 'Chekni koʻrish',
          emptyTitle: 'Toʻlovlar yoʻq',
          loadError: 'Toʻlovlarni yuklab boʻlmadi',
          columns: {
            type: 'Turi',
            description: 'Tavsif',
            amount: 'Summa',
            status: 'Holat',
            actions: 'Amallar',
          },
        },
      },
    },
    parties: {
      list: {
        title: 'Partiyalar',
        subtitle: 'Yuk yetkazib berish partiyalari',
        newParty: 'Yangi partiya',
        searchPlaceholder: 'Partiya nomi boʻyicha qidirish',
        loadError: 'Partiyalarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha partiya yoʻq',
        emptyDescription: 'Yangi partiya yarating yoki filtr shartlarini oʻzgartiring.',
        columns: {
          name: 'Nomi',
          status: 'Status',
          packages: 'Paketlar',
          createdAt: 'Yaratilgan',
          actions: 'Amallar',
        },
        actions: {
          view: 'Koʻrish',
          changeStatus: 'Statusni oʻzgartirish',
          delete: 'Oʻchirish',
          addPackage: 'Paket qoʻshish',
        },
      },
      detail: {
        subtitle: 'Partiya tafsilotlari',
        changeStatus: 'Statusni oʻzgartirish',
        manifest: 'Manifestni yuklab olish',
        manifestDownloading: 'Yuklab olinmoqda…',
        manifestError: 'Manifestni yuklab olishda xatolik yuz berdi.',
        notFound: 'Partiya topilmadi',
        createdAt: 'Yaratilgan: {{date}}',
        packagesCount: 'Paketlar soni:',
        addPackage: 'Paket qoʻshish',
        packagesTitle: 'Paketlar',
        packagesEmptyTitle: 'Paket biriktirilmagan',
        packagesEmptyDescription: 'Quyidagi roʻyxatdan paketlarni biriktiring.',
        packagesColumns: {
          name: 'Nomi',
          parcelsCount: 'Posilkalar soni',
          weight: 'Vazni',
          createdAt: 'Yaratilgan',
        },
      },
      addPackage: {
        title: 'Paket qoʻshish',
        description: '"{{name}}" partiyasiga paketlarni qoʻshing.',
        searchPlaceholder: 'Paket nomi boʻyicha qidirish',
        selectedCount: 'Tanlangan: {{count}}',
        submit: 'Saqlash',
        emptyTitle: 'Mos paket topilmadi',
        emptyDescription: 'Faqat boʻsh yoki shu partiyadagi paketlar koʻrinadi.',
        skippedTitle: 'Baʼzi paketlar oʻtkazib yuborildi:',
        inThisParty: 'Shu partiyada',
        bulk: {
          selectPage: 'Hammasini tanlash (bu sahifa)',
          unselectPage: 'Sahifa tanlovini bekor qilish',
          clear: 'Tozalash',
          revert: 'Bekor qilish (saqlanmagan)',
        },
        columns: {
          name: 'Nomi',
          parcelsCount: 'Posilkalar soni',
          weight: 'Vazni',
          createdAt: 'Yaratilgan',
        },
        skipReason: {
          not_found: 'Topilmadi',
          already_in_party: 'Allaqachon shu partiyada',
          in_other_party: 'Boshqa partiyada',
        },
        toast: {
          added: '{{count}} ta paket qoʻshildi',
          summary: 'Qoʻshildi: {{added}}, Olib tashlandi: {{removed}}, Oʻtkazib yuborildi: {{skipped}}',
          noChanges: 'Oʻzgartirish yoʻq',
          removeErrors: 'Olib tashlashda xatolik: {{count}}',
        },
      },
      addPackageInline: {
        title: 'Paket qoʻshish',
        subtitle: 'Kerakli paketlarni tanlang va pastdagi "Saqlash" tugmasini bosing.',
        addRow: 'Qoʻshish',
        selected: 'Tanlangan',
        save: 'Saqlash',
        selectedCount: 'Tanlangan: {{count}}',
        emptyTitle: 'Mos paket topilmadi',
        emptyDescription: 'Faqat hech qaysi partiyaga biriktirilmagan paketlar koʻrinadi.',
        parcelsCount: 'Posilkalar: {{count}}',
        toast: {
          added: '"{{name}}" paketi biriktirildi',
          bulkAdded: '{{count}} ta paket biriktirildi',
          bulkSkipped: '{{count}} ta o\'tkazib yuborildi: {{reason}}',
        },
      },
      create: {
        title: 'Yangi partiya',
        description: 'Partiyaga nom bering. Status keyinroq oʻzgartiriladi.',
        submit: 'Yaratish',
      },
      status: {
        title: 'Partiya statusini oʻzgartirish',
        description: '"{{name}}" partiyasi uchun yangi statusni tanlang. Oʻzgartirish foydalanuvchilarga bildirishnomalar yuboradi.',
        statusLabel: 'Status',
        statusPlaceholder: 'Statusni tanlang',
      },
      form: {
        nameLabel: 'Partiya nomi',
        namePlaceholder: 'Oktyabr-2025',
        errors: {
          nameMin: 'Nom kamida 2 belgi',
          tooLong: 'Juda uzun',
        },
      },
      delete: {
        button: "Partiyani o'chirish",
        title: "Partiyani o'chirasizmi?",
        description: "\"{{name}}\" partiyasini o'chirsangiz, unga bog'liq posilkalar \"Saralanmoqda\" holatiga qaytadi. Bu amalni qaytarib bo'lmaydi.",
        confirm: "Ha, o'chirish",
        toast: "Partiya o'chirildi",
      },
      toast: {
        created: 'Partiya yaratildi',
        statusChanged: 'Status oʻzgartirildi',
      },
    },
    parcels: {
      list: {
        title: 'Posilkalar',
        subtitle: 'Barcha posilkalarni boshqaring',
        newParcel: 'Yangi posilka',
        searchPlaceholder: 'Trek ID yoki nom boʻyicha qidirish',
        allStatuses: 'Barcha statuslar',
        emptyTitle: 'Posilka topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring yoki yangi posilka yarating.',
        loadError: 'Posilkalarni yuklab boʻlmadi',
        columns: {
          trekId: 'Trek ID',
          cargoId: 'Cargo ID',
          name: 'Nomi',
          fulfillment: 'Bajarilishi',
          split: 'Boʻlinish',
          pinfl: 'PINFL',
          total: 'Jami',
          date: 'Sana',
          hasDebt: 'Qarzdorlik',
          actions: 'Amallar',
        },
        splitBadge: 'Boʻlingan posilka',
        notSplitBadge: 'Boʻlinmagan posilka',
        debtor: 'Qarzdor',
        noDebt: 'Qarzi yoʻq',
        debtFilterAll: 'Barchasi',
        delivered: 'Yetkazildi',
        deliveredToCustomer: 'Mijozga yetkazildi',
        actions: {
          view: 'Koʻrish',
          approve: 'Tasdiqlash',
          reject: 'Rad etish',
          edit: 'Tahrirlash',
          delete: 'Oʻchirish',
        },
      },
      detail: {
        trek: 'Trek: {{trekId}}',
        approve: 'Tasdiqlash',
        reject: 'Rad etish',
        edit: 'Tahrirlash',
        delete: 'Oʻchirish',
        notFound: 'Posilka topilmadi',
        rejectReasonLabel: 'Rad etish sababi:',
        sections: {
          address: 'Manzil',
          recipient: 'Qabul qiluvchi',
          cargoId: 'Cargo ID',
          products: 'Mahsulotlar ({{count}})',
        },
        address: {
          name: 'Manzil nomi',
          region: 'Viloyat',
          city: 'Shahar',
          street: 'Koʻcha',
          info: 'Izoh',
        },
        recipient: {
          fullName: 'Ism Sharif',
          phone: 'Telefon',
          passport: 'Pasport',
          pinfl: 'PINFL',
          store: 'Doʻkon',
        },
        cargoId: {
          code: 'Cargo ID kodi',
          fullName: 'Toʻliq ism',
          phone: 'Telefon',
          empty: 'Cargo ID biriktirilmagan',
        },
        products: {
          empty: 'Mahsulotlar qoʻshilmagan',
          name: 'Mahsulot',
          quantity: 'Miqdori',
          unitPrice: '1 ta narxi',
          total: 'Jami',
          grandTotal: 'Jami',
        },
        charges: {
          title: 'Toʻlovlar',
          empty: 'Toʻlovlar yoʻq',
        },
      },
      create: {
        title: 'Yangi posilka',
        subtitle: 'Admin tomonidan yaratish',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
      },
      approve: {
        title: 'Posilkani tasdiqlash',
        duplicatesTitle: 'Diqqat — duplikatlar topildi',
        confirmDescription: '"{{name}}" posilkasini tasdiqlamoqchimisiz? PINFL limit avtomatik tekshiriladi.',
        duplicatesDescription:
          'Bu trek ID boʻyicha yana {{count}} ta DRAFT/PENDING posilka mavjud. Tasdiqlasangiz, ularning hammasi avtomatik oʻchiriladi. Davom etasizmi?',
        cancel: 'Bekor qilish',
        confirm: 'Tasdiqlash',
        continue: 'Ha, davom etish',
        trekId: 'Trek ID:',
        pinfl: 'PINFL:',
        totalAmount: 'Jami summa:',
      },
      reject: {
        title: 'Posilkani rad etish',
        description: '"{{name}}" posilkasini rad etmoqchimisiz?',
        cancel: 'Bekor qilish',
        confirm: 'Rad etish',
        reasonLabel: 'Sabab (ixtiyoriy)',
        reasonPlaceholder: 'Foydalanuvchiga koʻrsatiladigan izoh',
      },
      form: {
        sections: {
          cargoId: 'Cargo ID',
          basic: 'Asosiy maʼlumotlar',
          address: 'Yetkazib berish manzili',
          personal: 'Qabul qiluvchi va PINFL',
          confirmShipping: 'Joʻnatishga tasdiqlash',
          addToWarehouse: "Omborga qoʻshish",
        },
        confirmShipping: {
          label: 'Joʻnatishga tasdiqlangan',
          hint: 'Belgilang — posilka darhol "Saralanmoqda" holatiga oʻtkaziladi.',
          checking: 'Omborxona tekshirilmoqda…',
          disabled: {
            emptyTrekId: 'Trek ID kiriting',
            notInWarehouse: 'Posilka omborda topilmadi',
            inPackage: "Posilka paketga qo'shilgan",
          },
        },
        addToWarehouse: {
          label: "Omborga qoʻshish",
          hint: "Belgilansa, posilka yaratilganda Trek ID boʻyicha omborga ham qoʻshiladi.",
          checking: 'Omborxona tekshirilmoqda…',
          disabled: {
            emptyTrekId: 'Trek ID kiriting',
            alreadyInWarehouse: 'Trek ID allaqachon omborda mavjud',
          },
        },
        cargoId: {
          code: 'Cargo ID kodi',
          codePlaceholder: 'Aniq Cargo ID kodini kiriting',
          searchHint: 'Yoki ism yoki telefon boʻyicha qidiring',
          searchPlaceholder: 'Qidirish…',
          noResults: 'Hech narsa topilmadi',
          notFound: 'Cargo ID topilmadi',
          fullName: 'Toʻliq ism',
          phone: 'Telefon',
        },
        fields: {
          name: 'Posilka nomi',
          trekId: 'Trek ID',
          storeName: 'Doʻkon nomi (ixtiyoriy)',
          addressName: 'Manzil nomi',
          region: 'Viloyat',
          city: 'Shahar',
          street: 'Koʻcha',
          building: 'Uy raqami',
          apartment: 'Xonadon (ixtiyoriy)',
          additionalInfo: 'Qoʻshimcha koʻrsatmalar',
          lastName: 'Familiya',
          firstName: 'Ism',
          middleName: 'Otasining ismi',
          phone: 'Telefon',
          passport: 'Pasport seriya',
          pinfl: 'PINFL',
        },
        pinfl: {
          checking: 'Limit tekshirilmoqda…',
          usage: 'Limit: {{used}} / {{total}}',
        },
        errors: {
          cargoIdRequired: 'Cargo ID majburiy',
          nameRequired: 'Posilka nomi kerak',
          tooLong: 'Juda uzun',
          trekIdTooShort: 'Trek ID kamida 5 belgi',
          trekIdLength: 'Trek ID 5–255 belgi boʻlsin',
          trekIdInvalid: 'Faqat lotin, raqam, tire',
          addressNameRequired: 'Manzil nomi kerak',
          cityRequired: 'Shahar kerak',
          streetRequired: 'Koʻcha kerak',
          buildingRequired: 'Uy raqami kerak',
          firstNameRequired: 'Ism kerak',
          lastNameRequired: 'Familiya kerak',
          middleNameRequired: 'Otasining ismi kerak',
          phoneTooShort: 'Telefon juda qisqa',
          phoneInvalid: 'Telefon notoʻgʻri',
          passportRequired: 'Pasport seriyasi kerak',
          passportInvalid: '2 katta lotin harfdan keyin 7 raqam, jami 9 belgi',
          pinflLength: 'PINFL {{length}} ta raqam',
          pinflDigitsOnly: 'Faqat raqam',
          confirmRequiresProducts: 'Joʻnatishga tasdiqlash uchun kamida bitta mahsulot qoʻshing',
        },
      },
      toast: {
        created: 'Posilka yaratildi',
        approved: 'Posilka tasdiqlandi',
        rejected: 'Posilka rad etildi',
      },
      edit: {
        title: 'Posilkani tahrirlash',
        subtitle: '"{{name}}" posilkasini tahrirlash',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        toast: {
          updated: 'Posilka yangilandi',
        },
      },
      delete: {
        title: 'Posilkani oʻchirish',
        description: '"{{name}}" posilkasini oʻchirmoqchimisiz? Bu amalni qaytarib boʻlmaydi.',
        cancel: 'Bekor qilish',
        confirm: 'Oʻchirish',
        toast: {
          deleted: 'Posilka oʻchirildi',
        },
      },
      workflowStatus: {
        title: 'Posilka holati',
        cancelHint: 'Posilkani bekor qilsangiz holati "Jarayonda"ga qaytadi va mijoz uni qaytadan tahrirlay oladi. Bu amal faqat "Saralanmoqda" holatida mavjud — keyingi holatlarda admin ham qaytara olmaydi.',
        cancelAction: 'Posilkani bekor qilish',
        confirmTitle: 'Posilkani bekor qilasizmi?',
        confirmDescription: 'Posilka "Jarayonda" holatiga qaytariladi va mijoz uni tahrirlay oladi.',
        confirmAction: 'Ha, bekor qilish',
        toast: {
          reverted: 'Posilka "Jarayonda" holatiga qaytarildi',
        },
      },
      products: {
        title: 'Mahsulotlar ({{count}})',
        add: 'Mahsulot qoʻshish',
        edit: 'Tahrirlash',
        delete: 'Oʻchirish',
        empty: 'Mahsulotlar qoʻshilmagan',
        grandTotal: 'Jami',
        inlineRow: 'Mahsulot #{{index}}',
        columns: {
          name: 'Mahsulot',
          quantity: 'Miqdori',
          unitPrice: '1 ta narxi',
          total: 'Jami',
          actions: 'Amallar',
        },
        form: {
          addTitle: 'Mahsulot qoʻshish',
          editTitle: 'Mahsulotni tahrirlash',
          category: 'Kategoriya',
          categoryPlaceholder: 'Kategoriyani tanlang',
          subcategory: 'Subkategoriya',
          subcategoryPlaceholder: 'Subkategoriyani tanlang',
          fullName: 'Toʻliq nomi',
          quantity: 'Miqdori',
          pricePerItem: '1 ta narxi (USD)',
          cancel: 'Bekor qilish',
          save: 'Saqlash',
        },
        confirmDelete: {
          title: 'Mahsulotni oʻchirish',
          description: '"{{name}}" mahsulotini oʻchirmoqchimisiz?',
          cancel: 'Bekor qilish',
          confirm: 'Oʻchirish',
        },
        toast: {
          added: 'Mahsulot qoʻshildi',
          updated: 'Mahsulot yangilandi',
          deleted: 'Mahsulot oʻchirildi',
          partialFailure: 'Mahsulot saqlanmadi: {{count}} ta',
          fixRows: 'Mahsulot qatorlaridagi xatolarni toʻgʻrilang',
        },
        errors: {
          categoryRequired: 'Kategoriya tanlang',
          subcategoryRequired: 'Subkategoriya tanlang',
          fullNameRequired: 'Nomi kerak',
          tooLong: 'Juda uzun',
          quantityInvalid: 'Miqdori notoʻgʻri',
          quantityMin: 'Kamida 1',
          priceInvalid: 'Narx notoʻgʻri',
          priceMin: 'Narx 0 dan katta boʻlishi kerak',
        },
      },
    },
    warehouse: {
      title: 'Omborxona',
      tabs: {
        owned: 'Egasi bor posilkalar',
        orphan: 'Egasiz posilkalar',
      },
      owned: {
        searchPlaceholder: 'Trek ID yoki nom boʻyicha qidirish',
        emptyTitle: 'Posilka topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring.',
        loadError: 'Posilkalarni yuklab boʻlmadi',
        columns: {
          trekId: 'Trek ID',
          name: 'Nomi',
          owner: 'Egasi',
          fulfillment: 'Holati',
          date: 'Sana',
        },
      },
      list: {
        title: 'Omborxona',
        subtitle: 'Egasiz posilkalarni boshqaring',
        newProduct: 'Qoʻshish',
        scan: 'Skanerlash',
        searchPlaceholder: 'Trek ID yoki nom boʻyicha qidirish',
        allStatuses: 'Barcha statuslar',
        emptyTitle: 'Posilka topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring yoki egasiz posilka qoʻshing.',
        loadError: 'Posilkalarni yuklab boʻlmadi',
        columns: {
          trekId: 'Trek ID',
          name: 'Nomi',
          region: 'Viloyat',
          status: 'Status',
          linkedParcel: 'Bogʻlangan posilka',
          date: 'Sana',
          actions: 'Amallar',
        },
      },
      form: {
        createTitle: 'Egasiz posilka',
        editTitle: 'Egasiz posilkani tahrirlash',
        description: 'Faqat Trek ID majburiy, qolganlari ixtiyoriy.',
        kg: 'kg',
        fields: {
          trekId: 'Trek ID',
          name: 'Nomi',
          quantity: 'Miqdori',
          price: 'Narxi',
          weight: 'Vazni',
          note: 'Izoh',
          storeName: 'Doʻkon nomi',
          storeNamePlaceholder: 'Amazon, AliExpress, ...',
          cargoIdCode: 'Cargo ID kodi',
          cargoIdCodePlaceholder: 'T10001',
          address: 'Manzil',
          addressPlaceholder: 'Yetkazib berish manzili',
        },
        fio: {
          label: 'FIO',
          loading: 'Qidirilmoqda…',
          notFound: 'Topilmadi',
          empty: 'Cargo ID kodini kiriting',
        },
        errors: {
          trekIdRequired: 'Trek ID majburiy',
          tooLong: 'Juda uzun',
          invalidNumber: 'Notoʻgʻri qiymat',
          cargoIdNotFound: 'Cargo ID kodi topilmadi',
        },
      },
      formPage: {
        createTitle: 'Egasiz posilka qoʻshish',
        editTitle: 'Egasiz posilkani tahrirlash',
        notFound: 'Posilka topilmadi',
        loadError: 'Posilkani yuklab boʻlmadi',
      },
      scanner: {
        title: 'Skanerlash',
        titleOnly: 'Trek ID skanerlang',
        close: 'Yopish',
        toast: {
          added: '{{trekId}} qoʻshildi',
          duplicate: '{{trekId}} avval qoʻshilgan',
          wait: 'Iltimos, kuting',
        },
      },
      delete: {
        title: 'Posilkani oʻchirish',
        description: '{{trekId}} posilkasini oʻchirmoqchimisiz?',
        confirm: 'Oʻchirish',
        toast: {
          deleted: 'Posilka oʻchirildi',
        },
      },
      toast: {
        created: 'Posilka qoʻshildi',
        updated: 'Posilka yangilandi',
        duplicateTrekId: 'Bu trek ID bilan egasiz posilka allaqachon mavjud',
      },
    },
    warehouseArrivals: {
      tabs: { packages: 'Yetib kelgan paketlar', parcels: 'Yetib kelgan posilkalar' },
      packages: {
        searchPlaceholder: 'Nomi yoki ID boʻyicha qidirish',
        scan: 'Skanerlash',
        view: 'Koʻrish',
        deliveredToCustomer: 'Mijozga yetkazildi',
        delivered: { yes: 'Ha', no: 'Yoʻq' },
        emptyTitle: 'Paket topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring.',
        loadError: 'Paketlarni yuklab boʻlmadi',
        columns: { name: 'Nomi', uniqueId: 'Unikal ID', party: 'Partiya', parcels: 'Posilkalar', delivered: 'Mijozga yetkazildi', actions: 'Amallar' },
        toast: { delivered: 'Holat yangilandi' },
        confirm: {
          markTitle: 'Mijozga yetkazildi deb belgilash',
          markDescription: 'Ushbu paket mijozga yetkazildi deb belgilanadimi?',
          markConfirm: 'Ha, yetkazildi',
          cancelTitle: 'Yetkazilganni bekor qilish',
          cancelDescription: 'Ushbu paketning "yetkazildi" holati bekor qilinadimi?',
          cancelConfirm: 'Ha, bekor qilish',
          dismiss: 'Yopish',
        },
        viewTitle: 'Paket maʼlumotlari',
        notFound: 'Paket topilmadi',
        loadDetailError: 'Paketni yuklab boʻlmadi',
        fields: { name: 'Nomi', uniqueId: 'Unikal ID', party: 'Partiya', price: 'Narxi', weight: 'Vazni', parcels: 'Posilkalar' },
      },
      parcels: {
        searchPlaceholder: 'Trek ID yoki nom boʻyicha qidirish',
        view: 'Koʻrish',
        emptyTitle: 'Posilka topilmadi',
        emptyDescription: 'Filtr shartlarini oʻzgartiring.',
        loadError: 'Posilkalarni yuklab boʻlmadi',
        delivered: { yes: 'Ha', no: 'Yoʻq' },
        columns: { name: 'Nomi', trekId: 'Trek ID', pinfl: 'PINFL', delivered: 'Mijozga yetkazildi', split: 'Ajratish', actions: 'Amallar' },
        viewTitle: 'Posilka maʼlumotlari',
        notFound: 'Posilka topilmadi',
        loadDetailError: 'Posilkani yuklab boʻlmadi',
        fields: { name: 'Nomi', trekId: 'Trek ID', pinfl: 'PINFL', delivered: 'Mijozga yetkazildi', split: 'Ajratish' },
      },
      scan: {
        title: 'Skanerlang',
        placeholder: 'Unikal ID ni skanerlang yoki kiriting',
        submit: 'Tasdiqlash',
        close: 'Yopish',
        notArrived: 'Bu paket hali yetib kelmagan',
        notFound: 'Paket topilmadi',
        scanning: 'Skanerlang...',
      },
    },
    packages: {
      list: {
        title: 'Paketlar',
        subtitle: 'Paketlarni boshqaring',
        newPackage: 'Yangi paket',
        searchPlaceholder: 'Nomi boʻyicha qidirish',
        emptyTitle: 'Paket topilmadi',
        emptyDescription: 'Yangi paket yarating yoki filtrni oʻzgartiring.',
        loadError: 'Paketlarni yuklab boʻlmadi',
        columns: {
          name: 'Nomi',
          price: 'Narxi',
          weight: 'Vazni',
          parcelsCount: 'Posilkalar soni',
          createdAt: 'Sana',
          actions: 'Amallar',
        },
      },
      form: {
        createTitle: 'Yangi paket',
        editTitle: 'Paketni tahrirlash',
        notFound: 'Paket topilmadi',
        loadError: 'Paketni yuklab boʻlmadi',
        fields: {
          name: 'Nomi',
          uniqueId: 'Unikal ID',
          price: 'Narxi',
          weight: 'Vazni',
          weightUnit: 'Vazn birligi',
        },
        generate: 'Generatsiya',
        downloadQr: 'QR yuklab olish',
        weightUnit: {
          kg: 'kg',
          g: 'g',
        },
        errors: {
          nameRequired: 'Nomi majburiy',
          invalidNumber: 'Notoʻgʻri qiymat',
          tooLong: 'Juda uzun',
          parcelsRequired: 'Kamida bitta posilka qoʻshing',
        },
      },
      columns: {
        productName: 'Mahsulot nomi',
        quantity: 'Miqdori',
        unitPrice: '1ta narxi',
        totalPrice: 'Jami narxi',
        trekId: 'Trek ID',
        cargoId: 'Cargo ID',
        passport: 'Pasport',
        pinfl: 'PINFL',
        date: 'Sana',
        actions: 'Amallar',
        parcelName: 'Posilka nomi',
        products: 'Mahsulotlar',
      },
      parcelPicker: {
        title: 'Posilkalar',
        subtitle: 'Biriktirilgan posilkalar: {{count}}',
        addBtn: 'Posilka qoʻshish',
        emptyAttached: 'Hozircha posilka biriktirilmagan',
        selectedEmpty: 'Hech qanday posilka tanlanmagan',
        filters: {
          trekId: 'Trek ID boʻyicha qidirish',
          name: 'Mahsulot nomi boʻyicha qidirish',
          cargoId: 'Cargo ID boʻyicha qidirish',
        },
        dialog: {
          title: 'Posilka qoʻshish',
          searchPlaceholder: 'Trek ID / Mahsulot nomi / Cargo ID boʻyicha qidirish',
          emptyTitle: 'Mos posilka topilmadi',
          emptyDescription: 'Boshqa qidiruv soʻzi bilan urinib koʻring.',
          loadError: 'Posilkalarni yuklab boʻlmadi',
          addRow: 'Qoʻshish',
          alreadyAdded: 'Qoʻshilgan',
          productSingle: '{{name}} × {{qty}}',
          productSummary: '{{name}} × {{qty}} (+{{extra}})',
        },
      },
      delete: {
        title: 'Paketni oʻchirish',
        description: '"{{name}}" paketini oʻchirmoqchimisiz?',
        confirm: 'Oʻchirish',
      },
      toasts: {
        created: 'Paket yaratildi',
        updated: 'Paket yangilandi',
        deleted: 'Paket oʻchirildi',
      },
    },
    categories: {
      list: {
        title: 'Kategoriyalar',
        subtitle: 'Mahsulot kategoriyalari va subkategoriyalari',
        newCategory: 'Yangi kategoriya',
        loadError: 'Kategoriyalarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha kategoriya yoʻq',
        emptyDescription: 'Yangi kategoriya yarating va unga subkategoriyalar qoʻshing.',
        subcategoriesCount: '{{count}} ta sub',
        emptySubcategories: 'Hali subkategoriya yoʻq',
        expand: 'Ochish',
        collapse: 'Yopish',
        addSubcategory: 'Subkategoriya qoʻshish',
      },
      form: {
        createTitle: 'Yangi kategoriya',
        editTitle: 'Kategoriyani tahrirlash',
        description: 'Kategoriya nomini 3 tilda kiriting.',
        nameUz: 'Nomi (UZ)',
        nameRu: 'Nomi (RU)',
        nameEn: 'Nomi (EN)',
        nameKk: 'Nomi (KK)',
        errors: {
          nameUzRequired: 'Oʻzbekcha nom kerak',
          nameRuRequired: 'Ruscha nom kerak',
          nameEnRequired: 'Inglizcha nom kerak',
          tooLong: 'Juda uzun',
        },
      },
      subcategory: {
        createTitle: 'Yangi subkategoriya',
        editTitle: 'Subkategoriyani tahrirlash',
      },
      confirmDelete: {
        title: 'Kategoriyani oʻchirish',
        description: '"{{name}}" kategoriyasi barcha subkategoriyalari bilan oʻchadi.',
        confirm: 'Oʻchirish',
      },
      confirmDeleteSub: {
        title: 'Subkategoriyani oʻchirish',
        description: '"{{name}}" oʻchirilsinmi?',
        confirm: 'Oʻchirish',
      },
      toast: {
        created: 'Kategoriya yaratildi',
        updated: 'Kategoriya yangilandi',
        deleted: 'Kategoriya oʻchirildi',
        subCreated: 'Subkategoriya qoʻshildi',
        subUpdated: 'Subkategoriya yangilandi',
        subDeleted: 'Subkategoriya oʻchirildi',
      },
      reassign: {
        title: 'Mahsulotlarni koʻchirish',
        catDescription:
          '"{{name}}" kategoriyasi mahsulotlarda ishlatilmoqda. Oʻchirishdan oldin mahsulotlarni boshqa kategoriyaga koʻchiring.',
        subDescription:
          '"{{name}}" subkategoriyasi mahsulotlarda ishlatilmoqda. Oʻchirishdan oldin mahsulotlarni boshqa subkategoriyaga koʻchiring.',
        catLabel: 'Yangi kategoriya',
        subLabel: 'Yangi subkategoriya',
        placeholder: 'Tanlang',
        confirm: 'Koʻchirish va oʻchirish',
        catNoTargets: 'Koʻchirish uchun boshqa kategoriya yoʻq. Avval kategoriya yarating.',
        subNoTargets: 'Koʻchirish uchun boshqa subkategoriya yoʻq. Avval subkategoriya yarating.',
      },
    },
    staff: {
      list: {
        title: 'Xodimlar',
        subtitle: 'Tizimga kirish huquqi bor foydalanuvchilar',
        newStaff: 'Yangi xodim',
        searchPlaceholder: 'Ism, username, telefon boʻyicha',
        loadError: 'Xodimlarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha xodim yoʻq',
        active: 'Faol',
        inactive: 'Nofaol',
        activate: 'Faollashtirish',
        deactivate: 'Nofaollashtirish',
        superBadge: 'Super xodim',
        columns: {
          fullName: 'Toʻliq ism',
          username: 'Username',
          phone: 'Telefon',
          role: 'Rol',
          status: 'Status',
          createdAt: 'Yaratilgan',
          actions: 'Amallar',
        },
      },
      formPage: {
        createTitle: 'Yangi xodim',
        editTitle: 'Xodimni tahrirlash',
        notFound: 'Xodim topilmadi.',
        loadError: 'Xodimni yuklab boʻlmadi',
        superNote: 'Bu super xodim — rol bogʻlab boʻlmaydi',
      },
      form: {
        title: 'Yangi xodim',
        description: 'Xodim hisobi yarating. Parol bir marta koʻrsatiladi — saqlab qoʻying.',
        submit: 'Yaratish',
        fields: {
          fullName: 'Toʻliq ism',
          username: 'Username',
          password: 'Parol',
          passwordOptional: 'Yangi parol (ixtiyoriy)',
          passwordEditPlaceholder: 'Oʻzgartirmasangiz boʻsh qoldiring',
          phone: 'Telefon (ixtiyoriy)',
          phonePlaceholder: '+998901234567',
          role: 'Rol',
          rolePlaceholder: 'Rolni tanlang',
        },
        errors: {
          fullNameRequired: 'Toʻliq ism majburiy',
          usernameMin: 'Username kamida 3 belgi',
          usernameInvalid: 'Faqat lotin, raqam, _ . -',
          passwordMin: 'Parol kamida 6 belgi',
          tooLong: 'Juda uzun',
          roleRequired: 'Rol tanlanishi shart',
          rolesLoadFailed: 'Rollarni yuklab boʻlmadi',
        },
      },
      confirmDelete: {
        title: 'Xodimni oʻchirish',
        description: '"{{name}}" hisobi butunlay oʻchadi.',
        confirm: 'Oʻchirish',
      },
      confirmToggle: {
        deactivate: {
          title: 'Xodimni nofaollashtirish',
          description: '"{{name}}" hisobi nofaollashtiriladi — bu xodim tizimga kira olmaydi. Davom etasizmi?',
          confirm: 'Ha, nofaollashtirish',
        },
        activate: {
          title: 'Xodimni faollashtirish',
          description: '"{{name}}" hisobi qaytadan faollashtiriladi va xodim tizimga kira oladi.',
          confirm: 'Ha, faollashtirish',
        },
      },
      toast: {
        created: 'Xodim yaratildi',
        updated: 'Xodim yangilandi',
        deleted: 'Xodim oʻchirildi',
        activated: 'Xodim faollashtirildi',
        deactivated: 'Xodim nofaollashtirildi',
      },
    },
    supportStaff: {
      list: {
        title: 'Texnik yordamchi',
        subtitle: 'Mijozlarga yordam beruvchi mutaxassislar',
        emptyTitle: 'Hozircha yordamchi yoʻq',
        loadError: 'Yordamchilarni yuklab boʻlmadi',
        yearsSuffix: '{{count}} yil',
        create: 'Yangi yordamchi',
        columns: {
          image: 'Rasm',
          name: 'Ism',
          contact: 'Bogʻlanish havolasi',
          languages: 'Tillar',
          experience: 'Ish staji (yil)',
          createdAt: 'Yaratilgan',
          actions: 'Amallar',
        },
      },
      form: {
        createTitle: 'Yangi yordamchi',
        editTitle: 'Yordamchini tahrirlash',
        description: 'Yordamchi maʼlumotlarini kiriting.',
        fields: {
          name: 'Ism',
          contact: 'Bogʻlanish havolasi',
          languages: 'Tillar',
          experience: 'Ish staji (yil)',
          image: 'Rasm',
          pickImage: 'Rasm tanlash',
          languagesPlaceholder: 'Til kiriting va qoʻshing',
          addLanguage: 'Qoʻshish',
        },
        errors: {
          nameRequired: 'Ism majburiy',
          tooLong: 'Juda uzun',
          contactRequired: 'Bogʻlanish havolasi majburiy',
          contactInvalid: 'Havola notoʻgʻri',
          languagesRequired: 'Kamida bitta til qoʻshing',
          experienceMin: 'Ish staji 0 dan kichik boʻlmasin',
          imageType: 'Faqat rasm fayli',
          imageTooLarge: 'Rasm hajmi juda katta',
        },
        notFound: 'Yordamchi topilmadi',
      },
      toast: {
        created: 'Yordamchi qoʻshildi',
        updated: 'Yordamchi yangilandi',
        deleted: 'Yordamchi oʻchirildi',
      },
      confirmDelete: {
        title: 'Yordamchini oʻchirish',
        description: '"{{name}}" oʻchirilsinmi?',
        confirm: 'Oʻchirish',
      },
    },
    faqs: {
      list: {
        title: 'Savol-javoblar',
        subtitle: 'Mijozlar uchun tez-tez beriladigan savollar',
        newFaq: 'Yangi savol',
        loadError: 'Savol-javoblarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha savol yoʻq',
        emptyDescription: 'Birinchi savol-javobni qoʻshing.',
        active: 'Faol',
        inactive: 'Nofaol',
        activate: 'Faollashtirish',
        deactivate: 'Nofaollashtirish',
      },
      form: {
        createTitle: 'Yangi savol-javob',
        editTitle: 'Savol-javobni tahrirlash',
        description: 'Savol va javobni 3 tilda kiriting.',
        questionUz: 'Savol (UZ)',
        questionRu: 'Savol (RU)',
        questionEn: 'Savol (EN)',
        questionKk: 'Savol (KK)',
        answerUz: 'Javob (UZ)',
        answerRu: 'Javob (RU)',
        answerEn: 'Javob (EN)',
        answerKk: 'Javob (KK)',
        order: 'Tartib raqami',
        isActive: 'Faol',
        errors: {
          required: 'Majburiy maydon',
          tooLong: 'Juda uzun',
          order: 'Tartib 0 dan katta boʻlsin',
        },
      },
      confirmDelete: {
        title: 'Savolni oʻchirish',
        description: '"{{name}}" oʻchirilsinmi?',
        confirm: 'Oʻchirish',
      },
      confirmToggle: {
        activateTitle: 'Savolni faollashtirish',
        activateDescription: '"{{name}}" faollashtirilsinmi?',
        activateConfirm: 'Faollashtirish',
        deactivateTitle: 'Savolni nofaollashtirish',
        deactivateDescription: '"{{name}}" faolsizlantirilsinmi?',
        deactivateConfirm: 'Nofaollashtirish',
      },
      toast: {
        created: 'Savol qoʻshildi',
        updated: 'Savol yangilandi',
        deleted: 'Savol oʻchirildi',
        activated: 'Savol faollashtirildi',
        deactivated: 'Savol nofaollashtirildi',
      },
    },
    support: {
      list: {
        title: 'Qoʻllab-quvvatlash',
        subtitle: 'Mijozlar bilan yozishmalar',
        searchPlaceholder: 'Email yoki ism boʻyicha',
        loadError: 'Suhbatlarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha suhbat yoʻq',
        emptyDescription: 'Mijozlar xabar yozganda bu yerda koʻrinadi.',
        blocked: 'Bloklangan',
      },
      chat: {
        title: 'Suhbat',
        loadError: 'Suhbatni yuklab boʻlmadi',
        emptyTitle: 'Xabarlar yoʻq',
        emptyDescription: 'Birinchi xabarni yuboring.',
        messagePlaceholder: 'Xabar yozing…',
        send: 'Yuborish',
        attach: 'Fayl biriktirish',
        file: 'Fayl',
        fileTooLarge: 'Fayl hajmi 10MB dan oshmasligi kerak',
        block: 'Bloklash',
        unblock: 'Blokdan chiqarish',
        blockedState: 'Bloklangan',
        confirmBlock: {
          title: 'Mijozni bloklash',
          description: '"{{name}}" bloklanadi va sizga xabar yoza olmaydi. Davom etasizmi?',
          confirm: 'Ha, bloklash',
        },
        toast: {
          blocked: 'Mijoz bloklandi',
          unblocked: 'Mijoz blokdan chiqarildi',
        },
        info: {
          email: 'Email',
          name: 'Ism',
          phone: 'Telefon',
          languages: 'Tillar',
        },
      },
    },
    limitConfig: {
      title: 'PINFL limit sozlamasi',
      subtitle: 'Mijozlarning sarflash limiti va yangilanish davrini boshqaring',
      loadError: 'Sozlamani yuklab boʻlmadi',
      updatedAt: 'Oxirgi yangilanish: {{date}}',
      form: {
        amountSection: 'Limit miqdori',
        cadenceSection: 'Yangilanish davri',
        cadenceDescription: 'Limit har necha kunda yoki har necha oyda qaytadan tiklanadi',
        resetSection: 'Joriy sarflar',
        submit: 'Saqlash',
        periodUnit: {
          DAY: 'Kunlar',
          MONTH: 'Oylar',
        },
        fields: {
          amount: 'Limit miqdori (USD)',
          periodUnit: 'Davr birligi',
          periodValueDay: 'Har necha kunda',
          periodValueMonth: 'Har necha oyda',
          startDay: 'Oyning yangilanish kuni',
          startDate: 'Boshlanish sanasi',
          timezone: 'Vaqt mintaqasi',
          resetUsage: 'Limit oʻzgarganda mijozlar sarfini nolga tushirish',
        },
        hints: {
          amount: 'Har bir mijozning davr ichida sarflay oladigan yuqori chegarasi.',
          startDay: 'Agar kun 29–31 boʻlsa va oyda bunday kun boʻlmasa (masalan, fevral), yangilanish keyingi oyning 1-kuniga oʻtadi.',
          startDate: 'Kunlik davr shu sanadan boshlab hisoblanadi.',
          resetUsageOn: 'Barcha mijozlarning sarflangan summasi 0 ga tushiriladi.',
          resetUsageOff: 'Mijozlar sarflarini saqlab qoladi. Yangi limit pastroq boʻlsa, baʼzi mijozlar limitdan oshib ketishi mumkin.',
        },
        errors: {
          amountInvalid: 'Notoʻgʻri qiymat',
          amountMin: 'Manfiy boʻlishi mumkin emas',
          periodValueInvalid: 'Butun son kiriting',
          periodValueMin: 'Kamida 1 boʻlsin',
          startDayInvalid: 'Butun son kiriting',
          startDayRange: 'Kun 1 dan 31 gacha boʻlsin',
          timezoneRequired: 'Vaqt mintaqasini tanlang',
        },
      },
      toast: {
        saved: 'Limit sozlamasi saqlandi',
      },
    },
    pricing: {
      title: 'Narxlar',
      subtitle: 'Limit va xizmat narxlari',
      loadError: 'Narxlarni yuklab boʻlmadi',
      limitSection: 'Limit sozlamasi',
      pricingSection: 'Xizmat narxlari',
      fields: {
        limit: 'Limit',
        splitFee: 'Boʻlish narxi',
        packagePricePerKg: 'Paket narxi (kg)',
        photoFee: 'Rasm narxi',
        videoFee: 'Video narxi',
        proverkaFee: 'Tekshiruv narxi',
        returnFee: 'Vozvrat narxi',
      },
      toast: {
        savedLimit: 'Limit saqlandi',
        savedPricing: 'Narxlar saqlandi',
      },
      save: 'Saqlash',
    },
    serviceReports: {
      photo: {
        title: 'Rasm hisobotlari',
        subtitle: 'Mijozlarning rasm soʻrovlari',
      },
      video: {
        title: 'Video hisobotlari',
        subtitle: 'Mijozlarning video soʻrovlari',
      },
      proverka: {
        title: 'Tekshiruv hisobotlari',
        subtitle: 'Mijozlarning tekshiruv soʻrovlari',
      },
      columns: {
        parcel: 'Posilka',
        contact: 'Aloqa',
        note: 'Izoh',
        fee: 'Narx',
        status: 'Holat',
        createdAt: 'Sana',
        actions: 'Amal',
      },
      filter: {
        all: 'Barchasi',
        pending: 'Kutilmoqda',
        done: 'Yuborildi',
      },
      markDone: 'Yuborildi',
      cancel: 'Bekor qilish',
      cancelTitle: 'Soʻrovni bekor qilish',
      cancelDescription: '«{{name}}» posilka uchun bu soʻrovni bekor qilasizmi? Hisoblangan toʻlov ham bekor qilinadi va mijoz qayta soʻrov yubora oladi.',
      cancelConfirm: 'Ha, bekor qilish',
      markDoneTitle: 'Yuborildi deb belgilash',
      markDoneDescription: '«{{name}}» posilka uchun bu soʻrovni mijozga yuborildi deb belgilaysizmi?',
      markDoneConfirm: 'Ha, yuborildi',
      emptyTitle: 'Hisobot yoʻq',
      emptyDescription: 'Hozircha soʻrovlar yoʻq',
      loadError: 'Hisobotlarni yuklab boʻlmadi',
      status: {
        cancelled: 'Bekor qilingan',
      },
      toast: {
        done: 'Yuborildi deb belgilandi',
        cancelled: 'Bekor qilindi',
      },
    },
    returns: {
      title: 'Vozvratlar',
      subtitle: 'Mijozlarning vozvrat soʻrovlari',
      columns: {
        parcel: 'Posilka',
        note: 'Izoh',
        fee: 'Narx',
        status: 'Holat',
        createdAt: 'Sana',
        actions: 'Amal',
      },
      status: {
        pending: 'Kutilmoqda',
        confirmed: 'Tasdiqlangan',
        rejected: 'Rad etilgan',
        cancelled: 'Bekor qilingan',
      },
      confirm: 'Tasdiqlash',
      reject: 'Rad etish',
      cancel: 'Bekor qilish',
      confirmTitle: 'Vozvratni tasdiqlash',
      confirmDescription: '«{{name}}» posilka uchun bu vozvrat soʻrovini tasdiqlaysizmi?',
      confirmConfirm: 'Ha, tasdiqlash',
      rejectTitle: 'Vozvratni rad etish',
      rejectDescription: '«{{name}}» posilka uchun bu vozvrat soʻrovini rad etasizmi?',
      rejectReasonLabel: 'Rad etish sababi',
      rejectReasonPlaceholder: 'Sababni yozing (ixtiyoriy)',
      rejectConfirm: 'Ha, rad etish',
      cancelTitle: 'Vozvratni bekor qilish',
      cancelDescription: '«{{name}}» posilka uchun bu vozvrat soʻrovini bekor qilasizmi? Hisoblangan toʻlov ham bekor qilinadi va mijoz qayta soʻrov yubora oladi.',
      cancelConfirm: 'Ha, bekor qilish',
      filter: {
        all: 'Barchasi',
        pending: 'Kutilmoqda',
        confirmed: 'Tasdiqlangan',
        rejected: 'Rad etilgan',
      },
      toast: {
        confirmed: 'Tasdiqlandi',
        rejected: 'Rad etildi',
        cancelled: 'Bekor qilindi',
      },
      loadError: 'Vozvratlarni yuklab boʻlmadi',
      emptyTitle: 'Vozvrat yoʻq',
      emptyDescription: 'Hozircha soʻrovlar yoʻq',
    },
    clients: {
      empty: 'Maʼlumot yoʻq',
      list: {
        title: 'Mijozlar',
        subtitle: 'Roʻyxatdan oʻtgan mijozlar',
        searchPlaceholder: 'Email yoki ism boʻyicha qidirish',
        loadError: 'Mijozlarni yuklab boʻlmadi',
        emptyTitle: 'Hozircha mijoz yoʻq',
        emptyDescription: 'Qidiruv shartlarini oʻzgartiring.',
        columns: {
          email: 'Email',
          fullName: 'Toʻliq ism',
          phone: 'Telefon',
          status: 'Holat',
          createdAt: 'Qoʻshilgan sana',
          actions: 'Amallar',
        },
        actions: {
          view: 'Koʻrish',
        },
        status: {
          active: 'Faol',
          blocked: 'Bloklangan',
        },
      },
      detail: {
        subtitle: 'Mijoz maʼlumotlari',
        notFound: 'Mijoz topilmadi',
        infoSection: 'Shaxsiy maʼlumotlar',
        fields: {
          firstName: 'Ism',
          lastName: 'Familiya',
          email: 'Email',
          phone: 'Telefon',
          languages: 'Tillar',
          createdAt: 'Qoʻshilgan sana',
        },
      },
      block: {
        blockButton: 'Posilka yaratishni bloklash',
        unblockButton: 'Blokdan ochish',
        blockTitle: 'Posilka yaratishni bloklash',
        blockDescription: 'Mijozning posilka yaratish huquqi bloklanadi. Davom etasizmi?',
        unblockTitle: 'Blokdan ochish',
        unblockDescription: 'Mijozning posilka yaratish huquqi qayta tiklanadi. Davom etasizmi?',
        confirm: 'Tasdiqlash',
        cancel: 'Bekor qilish',
        toastBlocked: 'Mijoz posilka yaratishdan bloklandi',
        toastUnblocked: 'Mijoz blokdan ochildi',
      },
      claimedTrekIds: {
        title: 'Egalik qiladigan Trek IDʼlar',
        columns: {
          trekId: 'Trek ID',
          parcelStatus: 'Posilka holati',
          fulfillmentStatus: 'Bajarilishi',
          partyStatus: 'Partiya holati',
          cargoIdCode: 'Cargo ID',
          createdAt: 'Sana',
        },
        empty: 'Hozircha yoʻq',
        loadError: 'Trek IDʼlarni yuklab boʻlmadi',
      },
      receipts: {
        title: 'Toʻlov tarixi',
        columns: {
          number: 'Chek raqami',
          parcel: 'Posilka',
          amount: 'Summa',
          createdAt: 'Sana',
          actions: 'Amallar',
        },
        view: 'Koʻrish',
        pdf: 'PDF',
        empty: 'Toʻlovlar yoʻq',
        loadError: 'Toʻlov tarixini yuklab boʻlmadi',
      },
    },
    broadcast: {
      title: 'Eʼlon yuborish',
      subtitle: 'Barcha mijozlarga bildirishnoma yuboring',
      form: {
        textSection: 'Eʼlon matni',
        textHint: 'Matn barcha mijozlarga bildirishnoma sifatida yuboriladi.',
        imageSection: 'Rasm (ixtiyoriy)',
        imageHint: 'Eʼlonga rasm biriktirish mumkin (maksimal 10MB).',
        pickImage: 'Rasm tanlash',
        submit: 'Yuborish',
        fields: {
          textUz: 'Xabar (uz)',
          textUzPlaceholder: 'Eʼlon matnini kiriting…',
          textRu: 'Xabar (ru)',
          textRuPlaceholder: 'Eʼlon matnini rus tilida kiriting…',
          textEn: 'Xabar (en)',
          textEnPlaceholder: 'Eʼlon matnini ingliz tilida kiriting…',
          textKk: 'Xabar (kk)',
          textKkPlaceholder: 'Eʼlon matnini qozoq tilida kiriting…',
          textKkHint: 'Boʻsh qoldirilsa, qozoq tilidagi mijozlarga rus tilidagi matn koʻrsatiladi.',
        },
        errors: {
          textRequired: 'Matn majburiy',
          tooLong: 'Juda uzun',
          imageType: 'Faqat rasm fayllari',
          imageTooLarge: 'Rasm hajmi 10MB dan oshmasligi kerak',
        },
      },
      toast: {
        sent: 'Eʼlon {{count}} ta mijozga yuborildi',
      },
    },
    splits: {
      list: {
        title: 'Boʻlishlar',
        subtitle: 'Posilkalarni qabul qiluvchilarga boʻlish',
        searchPlaceholder: 'Trek raqami boʻyicha qidirish',
        loadError: 'Boʻlishlarni yuklab boʻlmadi',
        emptyTitle: 'Boʻlish topilmadi',
        emptyDescription: 'Hozircha boʻlishlar yoʻq',
        columns: {
          trekId: 'Trek',
          parcel: 'Posilka',
          status: 'Holat',
          targets: 'Qabul qiluvchilar',
          total: 'Jami',
          createdAt: 'Yaratilgan',
          actions: 'Amallar',
        },
      },
      status: {
        DRAFT: 'Qoralama',
        IN_PROGRESS: 'Jarayonda',
        DELIVERED: 'Yetkazilgan',
        RESERVED: 'Zaxiralangan',
        DISTRIBUTED: 'Taqsimlangan',
        CONFIRMED: 'Tasdiqlangan',
        CANCELLED: 'Bekor qilingan',
      },
      detail: {
        trek: 'Trek raqami: {{trek}}',
        notFound: 'Boʻlish topilmadi',
        loadError: 'Boʻlishni yuklab boʻlmadi',
        sections: {
          parcel: 'Manba posilka',
          targets: 'Qabul qiluvchilar',
          allocation: 'Taqsimlash',
        },
        parcel: {
          trekId: 'Trek',
          name: 'Nomi',
          pinfl: 'PINFL',
          serviceFee: 'Xizmat haqi',
          total: 'Jami summa',
        },
        target: {
          recipient: 'Qabul qiluvchi',
          pinfl: 'PINFL',
          address: 'Manzil',
          reserved: 'Zaxiralangan',
          total: 'Jami',
          package: 'Paket',
        },
        allocation: {
          product: 'Mahsulot',
          quantity: 'Miqdor',
          amount: 'Summa',
          total: 'Jami',
          empty: 'Taqsimlash yoʻq',
        },
        statusNote: {
          CANCELLED: 'Bu boʻlish bekor qilingan',
          RESERVED: 'Bu boʻlish zaxiralangan holatda',
        },
      },
      distribute: {
        title: 'Mahsulotlarni taqsimlash',
        hint: 'Har bir mahsulotni qabul qiluvchilar oʻrtasida taqsimlang',
        productHeader: 'Mahsulot',
        totalQty: 'Mavjud',
        unitPrice: 'Narxi',
        remaining: 'Qoldiq',
        targetTotal: 'Jami',
        overLimit: 'Limitdan oshdi',
        submit: 'Taqsimlash',
        errors: {
          overAllocated: 'Taqsimlangan miqdor mavjud sondan oshib ketdi',
          pinflLimit: 'PINFL {{pinfl}} limiti yetarli emas',
        },
        success: 'Taqsimlandi',
      },
      confirm: {
        button: 'Tasdiqlash',
        confirmTitle: 'Boʻlishni tasdiqlash',
        confirmDescription: 'Har bir qabul qiluvchi uchun paket yaratiladi. Davom etilsinmi?',
        confirmAction: 'Tasdiqlash',
        success: 'Paketlar yaratildi',
      },
      cancel: {
        button: 'Bekor qilish',
        confirmTitle: 'Boʻlishni bekor qilish',
        confirmDescription: 'Boʻlish bekor qilinadi va zaxiralar qaytariladi. Davom etilsinmi?',
        confirmAction: 'Bekor qilish',
        success: 'Boʻlish bekor qilindi',
      },
      empty: {
        products: 'Mahsulotlar yoʻq',
        targets: 'Qabul qiluvchilar yoʻq',
        allocations: 'Taqsimlash yoʻq',
      },
      save: {
        title: 'Saqlash',
        sections: {
          products: 'Mahsulotlar',
          recipients: 'PINFLlar (qabul qiluvchilar)',
          serviceFee: 'Xizmat haqi',
        },
        product: {
          name: 'Mahsulot nomi',
          quantity: 'Soni',
          unitPrice: 'Narxi',
        },
        recipient: {
          title: 'Qabul qiluvchi',
          pinfl: 'PINFL',
          firstName: 'Ism',
          lastName: 'Familiya',
          middleName: 'Otasining ismi',
          phone: 'Telefon',
          passport: 'Passport seriyasi',
          addressName: 'Manzil nomi',
          region: 'Viloyat',
          city: 'Shahar/tuman',
          street: 'Koʻcha',
          building: 'Uy',
          apartment: 'Xonadon',
          additionalInfo: 'Qoʻshimcha maʼlumot',
        },
        package: {
          name: 'Paket nomi',
          price: 'Paket narxi',
          priceOptional: 'Paket narxi (ixtiyoriy)',
          priceHint: 'Boʻsh boʻlsa vazndan hisoblanadi',
          weight: 'Vazni',
          weightUnit: 'Vazn birligi',
          uniqueId: 'Unikal ID',
        },
        allocations: {
          title: 'Mahsulotlar',
          product: 'Mahsulot',
          quantity: 'Soni',
          addProduct: 'Mahsulot qoʻshish',
          removeProduct: 'Oʻchirish',
          selectPlaceholder: 'Mahsulotni tanlang',
          empty: 'Mahsulot mavjud emas',
        },
        limit: {
          label: 'Limit',
          value: '{{used}} / {{ceiling}}',
        },
        addPinfl: 'PINFL qoʻshish',
        removePinfl: 'PINFLni oʻchirish',
        expand: 'Ochish',
        collapse: 'Yopish',
        serviceFeeLabel: 'Xizmat haqi',
        generate: 'Generatsiya',
        downloadQr: 'QR yuklab olish',
        serviceFeeComputed: 'Jami xizmat haqi: {{total}} ({{count}} × {{fee}})',
        submit: 'Saqlash',
        delete: 'Oʻchirish',
        deleteConfirmTitle: 'Boʻlishni oʻchirish',
        deleteConfirmDescription: 'Bu boʻlish butunlay oʻchiriladi. Davom etilsinmi?',
        readOnlyNote: 'Bu boʻlishni tahrirlash mumkin emas',
        success: 'Saqlandi',
        deleteSuccess: 'Boʻlish oʻchirildi',
        errors: {
          exceedsAvailable: 'Mavjud miqdordan oshib ketdi',
          saveFailed: 'Saqlab boʻlmadi',
          pinflRequired: 'PINFL majburiy',
          distributionExact: 'Quyidagi mahsulotlar toʻliq taqsimlanmagan: {{products}}',
        },
      },
    },
    },
  },
  ru: {
    translation: {
    common: {
      language: 'Язык',
      uzbek: 'Узбекский',
      russian: 'Русский',
      english: 'Английский',
      required: 'Обязательно',
      cancel: 'Отмена',
      save: 'Сохранить',
      confirm: 'Подтвердить',
      add: 'Добавить',
      edit: 'Редактировать',
      delete: 'Удалить',
      errorGeneric: 'Произошла ошибка',
      retry: 'Повторить',
      loading: 'Загрузка…',
      noData: 'Нет данных',
      noAccessTitle: 'Нет доступа',
      noAccessDescription: 'У вас недостаточно прав для этого раздела.',
    },
    ui: {
      nothingFound: 'Ничего не найдено',
      searchPlaceholder: 'Поиск…',
      prevPage: 'Предыдущая страница',
      nextPage: 'Следующая страница',
      close: 'Закрыть',
      menu: 'Меню',
      back: 'Назад',
    },
    errorBoundary: {
      title: 'Произошла ошибка',
      description: 'Пожалуйста, повторите попытку. Если проблема сохраняется, вернитесь на главную страницу.',
      retry: 'Повторить',
      goHome: 'На главную страницу',
    },
    dashboard: {
      title: 'Статистика',
      subtitle: 'Общий обзор системы',
      errorLoad: 'Не удалось загрузить статистику',
      stats: {
        totalParcels: 'Всего посылок',
        pending: 'На модерации',
        approved: 'Одобрено',
        rejected: 'Отклонено',
        parties: 'Партии',
        clients: 'Клиенты',
      },
      chart: {
        monthlyTitle: 'Посылки по месяцам',
        monthlySubtitle: 'Новые посылки за последние 6 месяцев',
        partiesTitle: 'Статусы партий',
        partiesSubtitle: 'Распределение текущих партий',
      },
    },
    regions: {
      TASHKENT_CITY: 'Город Ташкент',
      TASHKENT: 'Ташкентская область',
      FERGANA: 'Фергана',
      ANDIJAN: 'Андижан',
      NAMANGAN: 'Наманган',
      SAMARKAND: 'Самарканд',
      BUKHARA: 'Бухара',
      SIRDARYA: 'Сырдарья',
      SURKHANDARYA: 'Сурхандарья',
      NAVOI: 'Навои',
      QASHQADARYA: 'Кашкадарья',
      KHOREZM: 'Хорезм',
      JIZZAKH: 'Джизак',
      KARAKALPAKSTAN: 'Каракалпакстан',
      XIVA: 'Хива',
    },
    notFound: {
      title: 'Страница не найдена',
      description: 'Запрошенная страница не существует или была удалена.',
      goHome: 'На главную',
    },
    login: {
      title: 'Вход в систему',
      username: 'Имя пользователя',
      password: 'Пароль',
      submit: 'Войти',
      toastWelcome: 'Добро пожаловать!',
      errors: {
        usernameRequired: 'Имя пользователя обязательно',
        passwordRequired: 'Пароль обязателен',
        tooLong: 'Слишком длинно',
        invalidCredentials: 'Неверное имя пользователя или пароль',
        generic: 'Ошибка входа в систему',
      },
    },
    topbar: {
      user: {
        fallback: 'Пользователь',
        owner: 'Владелец',
      },
      menu: {
        logout: 'Выход',
      },
      toast: {
        signedOut: 'Вы вышли из системы',
      },
    },
    header: {
      user: 'Пользователь',
      superLabel: 'Супер сотрудник',
    },
    nav: {
      dashboard: 'Статистика',
      parcels: 'Посылки',
      parties: 'Партии',
      packages: 'Пакеты',
      splits: 'Разделения',
      cargoIds: 'Cargo ID',
      warehouse: 'Склад',
      categories: 'Категории',
      staff: 'Сотрудники',
      roles: 'Роли',
      clients: 'Клиенты',
      legacyClients: 'Старые клиенты',
      support: 'Поддержка',
      supportStaff: 'Технический помощник',
      broadcast: 'Отправить объявление',
      faqs: 'Вопросы и ответы',
      limitConfig: 'Настройка лимита',
      pricing: 'Цены',
      unreadTooltip: 'Непрочитанных сообщений: {{count}}',
      splitsPendingTooltip: 'Черновиков разделений: {{count}}',
      reportsPhoto: 'Фото-отчёты',
      reportsVideo: 'Видео-отчёты',
      reportsPhotoPendingTooltip: 'Ожидают фото-запросов: {{count}}',
      reportsVideoPendingTooltip: 'Ожидают видео-запросов: {{count}}',
      reportsProverka: 'Проверки',
      reportsProverkaPendingTooltip: 'Ожидают проверок: {{count}}',
      returns: 'Возвраты',
      returnsPendingTooltip: 'Ожидают возвратов: {{count}}',
    },
    userStatus: {
      ghost: 'Гость',
      user: 'Пользователь',
      admin: 'Админ',
    },
    legacyClients: {
      list: {
        title: 'Старые клиенты',
        subtitle: 'Клиенты, перенесённые из старой системы',
        searchPlaceholder: 'Поиск по имени, телефону, Cargo ID или username',
        emptyTitle: 'Старые клиенты не найдены',
        emptyDescription: 'Измените условия поиска.',
        loadError: 'Не удалось загрузить старых клиентов',
        columns: {
          cargoIdCode: 'Cargo ID',
          fullName: 'ФИО',
          phone: 'Телефон',
          username: 'Username',
          telegramName: 'Имя в Telegram',
          formCount: 'Анкеты',
          userStatus: 'Статус',
          createdAt: 'Создано',
        },
      },
    },
    roles: {
      OWNER: 'Супер админ',
      JAPAN_WORKER: 'Сотрудник в Японии',
      UZBEK_WORKER: 'Сотрудник в Узбекистане',
      list: {
        title: 'Роли',
        subtitle: 'Управление ролями и правами пользователей',
        newRole: 'Новая роль',
        loadError: 'Не удалось загрузить роли',
        emptyTitle: 'Ролей пока нет',
        superBadge: 'Супер',
        customBadge: 'Обычная',
        columns: {
          name: 'Название',
          kind: 'Тип',
          permissions: 'Права',
          staffCount: 'Сотрудники',
          createdAt: 'Создана',
          actions: 'Действия',
        },
      },
      create: {
        title: 'Новая роль',
        description: 'Задайте имя роли и отметьте нужные права.',
        submit: 'Создать',
      },
      edit: {
        title: 'Редактирование роли',
        superTitle: 'Просмотр супер-роли',
        description: 'Обновите название и права роли.',
        submit: 'Сохранить',
      },
      formPage: {
        createTitle: 'Новая роль',
        editTitle: 'Редактирование роли',
        notFound: 'Роль не найдена.',
        loadError: 'Не удалось загрузить роль',
      },
      delete: {
        title: 'Удаление роли',
        description: 'Удалить роль "{{name}}"? Сначала перенесите всех сотрудников на другую роль.',
        reassignLabel: 'Роль для переноса сотрудников',
        reassignHint: 'Все сотрудники этой роли будут перенесены на выбранную, затем роль будет удалена.',
        staffWarning: 'В этой роли {{count}} сотрудников. Все будут перенесены.',
        noTargets: 'Других ролей не найдено. Сначала создайте новую роль.',
        confirm: 'Удалить',
      },
      form: {
        fields: {
          name: 'Название роли',
          permissions: 'Права доступа',
        },
        errors: {
          nameRequired: 'Название обязательно',
          tooLong: 'Слишком длинно',
        },
      },
      treePicker: {
        selectAll: 'Выбрать все',
        selectedCount: 'Выбрано: {{count}} / {{total}}',
        loadError: 'Не удалось загрузить список прав',
        nodes: {
          dashboard: 'Статистика',
          parcels: 'Посылки',
          cargo_ids: 'Cargo ID',
          parties: 'Партии',
          warehouse: 'Склад',
          clients: 'Клиенты',
          staff: 'Сотрудники',
          roles: 'Роли',
          categories: 'Категории',
          faqs: 'Вопросы и ответы',
          broadcast: 'Объявления',
          support: 'Поддержка',
          view: 'Просмотр',
          list: 'Список',
          detail: 'Подробности',
          create: 'Создание',
          update: 'Изменение',
          edit: 'Редактирование',
          delete: 'Удаление',
          column: 'Колонка',
          filter: 'Фильтр',
          approve: 'Одобрение',
          reject: 'Отклонение',
          export: 'Экспорт',
          manage: 'Управление',
          scan: 'Сканирование',
          block: 'Блокировка',
          unblock: 'Разблокировка',
          respond: 'Ответ',
          send: 'Отправка',
          revert_shipping: 'Отмена отправки',
          change_status: 'Изменить статус',
          add_packages: 'Добавление посылок',
          claimed_trek_ids: 'Привязанные Trek ID',
          search: 'Поиск',
          status: 'Статус',
          cargo_id: 'Cargo ID',
          trek_id: 'Trek ID',
          name: 'Название',
          cargo_id_code: 'Код Cargo ID',
          fulfillment_status: 'Статус отправки',
          region: 'Регион',
          created_at: 'Дата создания',
          splits: 'Распределения',
          distribute: 'Распределить/Сохранить',
          support_staff: 'Технический помощник',
          mark_delivered: 'Отметить как доставлено',
          arrived_packages: 'Прибывшие пакеты',
          arrived_parcels: 'Прибывшие посылки',
        },
      },
      superNotice: 'Эта роль имеет все права. Изменение запрещено.',
      toast: {
        created: 'Роль создана',
        updated: 'Роль обновлена',
        deleted: 'Роль удалена',
      },
    },
    parcelStatus: {
      DRAFT: 'Черновик',
      PENDING: 'На модерации',
      APPROVED: 'Одобрен',
      REJECTED: 'Отклонён',
    },
    fulfillmentStatus: {
      IN_PROGRESS: 'Ожидаемые',
      SORTING: 'На складе',
      COLLECTING: 'отправить в упаковку',
      SHIPPING: 'в процессе отправки',
      ON_THE_WAY: 'В пути',
      ON_CUSTOMS: 'на таможне',
      LOCAL_ON_THE_WAY: 'поступило на склад',
      SHIPMENT_ON_CUSTOMERS: 'Выдано получателю',
      WAITING: 'Ожидает',
      CONFIRMED: 'Подтверждён',
      PACKAGED: 'Упакован',
    },
    warehouseStatus: {
      UNCLAIMED: 'Активный',
      LINKED: 'Неактивный',
    },
    partyStatus: {
      COLLECTING: 'отправить в упаковку',
      SHIPPING: 'в процессе отправки',
      ON_THE_WAY: 'В пути',
      ON_CUSTOMS: 'на таможне',
      LOCAL_ON_THE_WAY: 'поступило на склад',
      SHIPMENT_ON_CUSTOMERS: 'Выдано получателю',
    },
    cargoIdType: {
      PHYSICAL: 'Физическое',
      LEGAL: 'Юридическое',
    },
    cargoIds: {
      list: {
        title: 'Cargo ID',
        subtitle: 'Управление Cargo ID',
        searchPlaceholder: 'Поиск по коду, имени или телефону',
        loadError: 'Не удалось загрузить Cargo ID',
        emptyTitle: 'Cargo ID не найдены',
        emptyDescription: 'Измените условия фильтра.',
        columns: {
          code: 'Код',
          type: 'Тип',
          fullName: 'ФИО',
          phone: 'Телефон',
          parcelsCount: 'Кол-во посылок',
          createdAt: 'Создан',
          debt: 'Задолженность',
          actions: 'Действия',
        },
        actions: {
          view: 'Просмотр',
        },
      },
      detail: {
        subtitle: 'Детали Cargo ID',
        notFound: 'Cargo ID не найден',
        noCode: 'Код не присвоен',
        empty: 'Нет данных',
        fields: {
          fullName: 'ФИО',
          phone: 'Телефон',
          region: 'Регион',
          type: 'Тип',
          createdAt: 'Создан',
        },
        owner: {
          title: 'Владелец',
          fullName: 'ФИО',
          phone: 'Телефон',
          passport: 'Паспорт',
          pinfl: 'ПИНФЛ',
          openClient: 'Открыть профиль клиента',
          empty: 'Владелец не привязан',
        },
        parcels: {
          title: 'Посылки',
          loadError: 'Не удалось загрузить посылки',
          emptyTitle: 'Нет посылок',
          view: 'Просмотр',
          columns: {
            name: 'Название',
            trekId: 'Трек ID',
            status: 'Статус',
            total: 'Итого',
            createdAt: 'Дата',
            actions: 'Действия',
          },
        },
        charges: {
          title: 'Задолженность',
          statusPaid: 'Оплачено',
          statusUnpaid: 'Не оплачено',
          statusFree: 'Бесплатно',
          markPaid: 'Оплачено',
          markUnpaid: 'Не оплачено',
          markPaidTitle: 'Подтверждение оплаты',
          markPaidDescription: 'Отметить платёж «{{type}}» — {{amount}} как оплаченный?',
          markPaidConfirm: 'Да, оплачено',
          markPaidToast: 'Платёж отмечен как оплаченный',
          markUnpaidToast: 'Оплата отменена',
          paidSuccessTitle: 'Успешно оплачено',
          paidSuccessBody: 'Платёж принят, чек сформирован.',
          viewReceipt: 'Посмотреть чек',
          emptyTitle: 'Нет платежей',
          loadError: 'Не удалось загрузить платежи',
          columns: {
            type: 'Тип',
            description: 'Описание',
            amount: 'Сумма',
            status: 'Статус',
            actions: 'Действия',
          },
        },
      },
    },
    parties: {
      list: {
        title: 'Партии',
        subtitle: 'Партии грузовой доставки',
        newParty: 'Новая партия',
        searchPlaceholder: 'Поиск по названию партии',
        loadError: 'Не удалось загрузить партии',
        emptyTitle: 'Партий пока нет',
        emptyDescription: 'Создайте новую партию или измените условия фильтра.',
        columns: {
          name: 'Название',
          status: 'Статус',
          packages: 'Пакеты',
          createdAt: 'Создано',
          actions: 'Действия',
        },
        actions: {
          view: 'Просмотр',
          changeStatus: 'Изменить статус',
          delete: 'Удаление',
          addPackage: 'Добавить пакет',
        },
      },
      detail: {
        subtitle: 'Детали партии',
        changeStatus: 'Изменить статус',
        manifest: 'Скачать манифест',
        manifestDownloading: 'Загрузка…',
        manifestError: 'Не удалось скачать манифест.',
        notFound: 'Партия не найдена',
        createdAt: 'Создано: {{date}}',
        packagesCount: 'Количество пакетов:',
        addPackage: 'Добавить пакет',
        packagesTitle: 'Пакеты',
        packagesEmptyTitle: 'Пакеты не привязаны',
        packagesEmptyDescription: 'Используйте кнопку «Добавить пакет», чтобы привязать пакеты.',
        packagesColumns: {
          name: 'Название',
          parcelsCount: 'Кол-во посылок',
          weight: 'Вес',
          createdAt: 'Создано',
        },
      },
      addPackage: {
        title: 'Добавить пакет',
        description: 'Добавьте пакеты в партию "{{name}}".',
        searchPlaceholder: 'Поиск по названию пакета',
        selectedCount: 'Выбрано: {{count}}',
        submit: 'Сохранить',
        emptyTitle: 'Подходящих пакетов нет',
        emptyDescription: 'Показываются только свободные пакеты или пакеты этой партии.',
        skippedTitle: 'Некоторые пакеты пропущены:',
        inThisParty: 'В этой партии',
        bulk: {
          selectPage: 'Выбрать все (на странице)',
          unselectPage: 'Снять выбор страницы',
          clear: 'Очистить',
          revert: 'Отменить (несохранённое)',
        },
        columns: {
          name: 'Название',
          parcelsCount: 'Кол-во посылок',
          weight: 'Вес',
          createdAt: 'Создано',
        },
        skipReason: {
          not_found: 'Не найден',
          already_in_party: 'Уже в этой партии',
          in_other_party: 'В другой партии',
        },
        toast: {
          added: 'Добавлено пакетов: {{count}}',
          summary: 'Добавлено: {{added}}, Удалено: {{removed}}, Пропущено: {{skipped}}',
          noChanges: 'Нет изменений',
          removeErrors: 'Ошибок при удалении: {{count}}',
        },
      },
      addPackageInline: {
        title: 'Добавить пакет',
        subtitle: 'Выберите нужные пакеты и нажмите кнопку «Сохранить» внизу.',
        addRow: 'Добавить',
        selected: 'Выбрано',
        save: 'Сохранить',
        selectedCount: 'Выбрано: {{count}}',
        emptyTitle: 'Подходящие пакеты не найдены',
        emptyDescription: 'Показываются только пакеты, не привязанные ни к одной партии.',
        parcelsCount: 'Посылок: {{count}}',
        toast: {
          added: 'Пакет «{{name}}» привязан',
          bulkAdded: 'Привязано пакетов: {{count}}',
          bulkSkipped: 'Пропущено: {{count}}: {{reason}}',
        },
      },
      create: {
        title: 'Новая партия',
        description: 'Дайте партии название. Статус можно изменить позже.',
        submit: 'Создать',
      },
      status: {
        title: 'Изменить статус партии',
        description: 'Выберите новый статус для партии "{{name}}". Изменение отправит уведомления пользователям.',
        statusLabel: 'Статус',
        statusPlaceholder: 'Выберите статус',
      },
      form: {
        nameLabel: 'Название партии',
        namePlaceholder: 'Октябрь-2025',
        errors: {
          nameMin: 'Название минимум 2 символа',
          tooLong: 'Слишком длинно',
        },
      },
      delete: {
        button: 'Удалить партию',
        title: 'Удалить партию?',
        description: 'Если удалить партию "{{name}}", связанные посылки вернутся в статус "Сортировка". Это действие нельзя отменить.',
        confirm: 'Да, удалить',
        toast: 'Партия удалена',
      },
      toast: {
        created: 'Партия создана',
        statusChanged: 'Статус изменён',
      },
    },
    parcels: {
      list: {
        title: 'Посылки',
        subtitle: 'Управление всеми посылками',
        newParcel: 'Новая посылка',
        searchPlaceholder: 'Поиск по Trek ID или названию',
        allStatuses: 'Все статусы',
        emptyTitle: 'Посылки не найдены',
        emptyDescription: 'Измените условия фильтра или создайте новую посылку.',
        loadError: 'Не удалось загрузить посылки',
        columns: {
          trekId: 'Trek ID',
          cargoId: 'Cargo ID',
          name: 'Название',
          fulfillment: 'Исполнение',
          split: 'Разделение',
          pinfl: 'ПИНФЛ',
          total: 'Итого',
          date: 'Дата',
          hasDebt: 'Задолженность',
          actions: 'Действия',
        },
        splitBadge: 'Разделённая посылка',
        notSplitBadge: 'Неразделённая посылка',
        debtor: 'Должник',
        noDebt: 'Нет долга',
        debtFilterAll: 'Все',
        delivered: 'Доставлено',
        deliveredToCustomer: 'Доставлено клиенту',
        actions: {
          view: 'Просмотр',
          approve: 'Подтвердить',
          reject: 'Отклонить',
          edit: 'Редактировать',
          delete: 'Удалить',
        },
      },
      detail: {
        trek: 'Trek: {{trekId}}',
        approve: 'Подтвердить',
        reject: 'Отклонить',
        edit: 'Редактировать',
        delete: 'Удалить',
        notFound: 'Посылка не найдена',
        rejectReasonLabel: 'Причина отклонения:',
        sections: {
          address: 'Адрес',
          recipient: 'Получатель',
          cargoId: 'Cargo ID',
          products: 'Товары ({{count}})',
        },
        address: {
          name: 'Название адреса',
          region: 'Регион',
          city: 'Город',
          street: 'Улица',
          info: 'Примечание',
        },
        recipient: {
          fullName: 'ФИО',
          phone: 'Телефон',
          passport: 'Паспорт',
          pinfl: 'ПИНФЛ',
          store: 'Магазин',
        },
        cargoId: {
          code: 'Код Cargo ID',
          fullName: 'ФИО',
          phone: 'Телефон',
          empty: 'Cargo ID не привязан',
        },
        products: {
          empty: 'Товары не добавлены',
          name: 'Товар',
          quantity: 'Количество',
          unitPrice: 'Цена за шт.',
          total: 'Итого',
          grandTotal: 'Итого',
        },
        charges: {
          title: 'Платежи',
          empty: 'Платежей нет',
        },
      },
      create: {
        title: 'Новая посылка',
        subtitle: 'Создание администратором',
        cancel: 'Отмена',
        save: 'Сохранить',
      },
      approve: {
        title: 'Подтверждение посылки',
        duplicatesTitle: 'Внимание — найдены дубликаты',
        confirmDescription: 'Подтвердить посылку "{{name}}"? Лимит ПИНФЛ будет проверен автоматически.',
        duplicatesDescription:
          'По этому Trek ID есть ещё {{count}} посылок в статусе DRAFT/PENDING. При подтверждении все они будут автоматически удалены. Продолжить?',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        continue: 'Да, продолжить',
        trekId: 'Trek ID:',
        pinfl: 'ПИНФЛ:',
        totalAmount: 'Общая сумма:',
      },
      reject: {
        title: 'Отклонение посылки',
        description: 'Отклонить посылку "{{name}}"?',
        cancel: 'Отмена',
        confirm: 'Отклонить',
        reasonLabel: 'Причина (необязательно)',
        reasonPlaceholder: 'Комментарий, который увидит пользователь',
      },
      form: {
        sections: {
          cargoId: 'Cargo ID',
          basic: 'Основные данные',
          address: 'Адрес доставки',
          personal: 'Получатель и ПИНФЛ',
          confirmShipping: 'Подтверждение отправки',
          addToWarehouse: 'Добавить на склад',
        },
        confirmShipping: {
          label: 'Подтверждено к отправке',
          hint: 'Отметьте — посылка сразу перейдёт в статус «Сортировка».',
          checking: 'Проверка склада…',
          disabled: {
            emptyTrekId: 'Введите Trek ID',
            notInWarehouse: 'Посылка не найдена на складе',
            inPackage: 'Посылка добавлена в пакет',
          },
        },
        addToWarehouse: {
          label: 'Добавить на склад',
          hint: 'Если отметить, при создании посылка также добавится на склад по Trek ID.',
          checking: 'Проверка склада…',
          disabled: {
            emptyTrekId: 'Введите Trek ID',
            alreadyInWarehouse: 'Trek ID уже есть на складе',
          },
        },
        cargoId: {
          code: 'Код Cargo ID',
          codePlaceholder: 'Введите точный код Cargo ID',
          searchHint: 'Или найдите по имени или телефону',
          searchPlaceholder: 'Поиск…',
          noResults: 'Ничего не найдено',
          notFound: 'Cargo ID не найден',
          fullName: 'Полное имя',
          phone: 'Телефон',
        },
        fields: {
          name: 'Название посылки',
          trekId: 'Trek ID',
          storeName: 'Название магазина (необязательно)',
          addressName: 'Название адреса',
          region: 'Регион',
          city: 'Город',
          street: 'Улица',
          building: 'Номер дома',
          apartment: 'Квартира (необязательно)',
          additionalInfo: 'Дополнительные указания',
          lastName: 'Фамилия',
          firstName: 'Имя',
          middleName: 'Отчество',
          phone: 'Телефон',
          passport: 'Серия паспорта',
          pinfl: 'ПИНФЛ',
        },
        pinfl: {
          checking: 'Проверка лимита…',
          usage: 'Лимит: {{used}} / {{total}}',
        },
        errors: {
          cargoIdRequired: 'Cargo ID обязателен',
          nameRequired: 'Введите название посылки',
          tooLong: 'Слишком длинно',
          trekIdTooShort: 'Trek ID минимум 5 символов',
          trekIdLength: 'Trek ID 5–255 символов',
          trekIdInvalid: 'Только латиница, цифры, дефис',
          addressNameRequired: 'Введите название адреса',
          cityRequired: 'Введите город',
          streetRequired: 'Введите улицу',
          buildingRequired: 'Введите номер дома',
          firstNameRequired: 'Введите имя',
          lastNameRequired: 'Введите фамилию',
          middleNameRequired: 'Введите отчество',
          phoneTooShort: 'Слишком короткий телефон',
          phoneInvalid: 'Неверный формат телефона',
          passportRequired: 'Введите серию паспорта',
          passportInvalid: '2 заглавные латинские буквы и 7 цифр, всего 9 символов',
          pinflLength: 'ПИНФЛ — {{length}} цифр',
          pinflDigitsOnly: 'Только цифры',
          confirmRequiresProducts: 'Для подтверждения отправки добавьте хотя бы один товар',
        },
      },
      toast: {
        created: 'Посылка создана',
        approved: 'Посылка подтверждена',
        rejected: 'Посылка отклонена',
      },
      edit: {
        title: 'Редактирование посылки',
        subtitle: 'Редактирование посылки "{{name}}"',
        cancel: 'Отмена',
        save: 'Сохранить',
        toast: {
          updated: 'Посылка обновлена',
        },
      },
      delete: {
        title: 'Удаление посылки',
        description: 'Удалить посылку "{{name}}"? Это действие необратимо.',
        cancel: 'Отмена',
        confirm: 'Удалить',
        toast: {
          deleted: 'Посылка удалена',
        },
      },
      workflowStatus: {
        title: 'Статус посылки',
        cancelHint: 'При отмене статус посылки вернётся в "В процессе", и клиент сможет её снова редактировать. Действие доступно только в статусе "Сортировка" — на более поздних этапах админ тоже не сможет вернуть.',
        cancelAction: 'Отменить посылку',
        confirmTitle: 'Отменить посылку?',
        confirmDescription: 'Посылка вернётся в статус "В процессе", и клиент сможет её редактировать.',
        confirmAction: 'Да, отменить',
        toast: {
          reverted: 'Посылка возвращена в "В процессе"',
        },
      },
      products: {
        title: 'Товары ({{count}})',
        add: 'Добавить товар',
        edit: 'Редактировать',
        delete: 'Удалить',
        empty: 'Товары не добавлены',
        grandTotal: 'Итого',
        inlineRow: 'Товар #{{index}}',
        columns: {
          name: 'Товар',
          quantity: 'Кол-во',
          unitPrice: 'Цена за шт.',
          total: 'Итого',
          actions: 'Действия',
        },
        form: {
          addTitle: 'Добавить товар',
          editTitle: 'Редактировать товар',
          category: 'Категория',
          categoryPlaceholder: 'Выберите категорию',
          subcategory: 'Подкатегория',
          subcategoryPlaceholder: 'Выберите подкатегорию',
          fullName: 'Полное название',
          quantity: 'Количество',
          pricePerItem: 'Цена за шт. (USD)',
          cancel: 'Отмена',
          save: 'Сохранить',
        },
        confirmDelete: {
          title: 'Удаление товара',
          description: 'Удалить товар "{{name}}"?',
          cancel: 'Отмена',
          confirm: 'Удалить',
        },
        toast: {
          added: 'Товар добавлен',
          updated: 'Товар обновлён',
          deleted: 'Товар удалён',
          partialFailure: 'Товары не сохранены: {{count}}',
          fixRows: 'Исправьте ошибки в строках товаров',
        },
        errors: {
          categoryRequired: 'Выберите категорию',
          subcategoryRequired: 'Выберите подкатегорию',
          fullNameRequired: 'Укажите название',
          tooLong: 'Слишком длинно',
          quantityInvalid: 'Неверное количество',
          quantityMin: 'Минимум 1',
          priceInvalid: 'Неверная цена',
          priceMin: 'Цена должна быть больше 0',
        },
      },
    },
    warehouse: {
      title: 'Склад',
      tabs: {
        owned: 'Посылки с владельцем',
        orphan: 'Бесхозные посылки',
      },
      owned: {
        searchPlaceholder: 'Поиск по Trek ID или названию',
        emptyTitle: 'Посылки не найдены',
        emptyDescription: 'Измените условия фильтра.',
        loadError: 'Не удалось загрузить посылки',
        columns: {
          trekId: 'Trek ID',
          name: 'Название',
          owner: 'Владелец',
          fulfillment: 'Статус',
          date: 'Дата',
        },
      },
      list: {
        title: 'Склад',
        subtitle: 'Управление бесхозными посылками',
        newProduct: 'Добавить',
        scan: 'Сканировать',
        searchPlaceholder: 'Поиск по Trek ID или названию',
        allStatuses: 'Все статусы',
        emptyTitle: 'Посылки не найдены',
        emptyDescription: 'Измените условия фильтра или добавьте бесхозную посылку.',
        loadError: 'Не удалось загрузить посылки',
        columns: {
          trekId: 'Trek ID',
          name: 'Название',
          region: 'Регион',
          status: 'Статус',
          linkedParcel: 'Связанная посылка',
          date: 'Дата',
          actions: 'Действия',
        },
      },
      form: {
        createTitle: 'Бесхозная посылка',
        editTitle: 'Редактировать бесхозную посылку',
        description: 'Обязателен только Trek ID, остальное необязательно.',
        kg: 'кг',
        fields: {
          trekId: 'Trek ID',
          name: 'Название',
          quantity: 'Количество',
          price: 'Цена',
          weight: 'Вес',
          note: 'Примечание',
          storeName: 'Название магазина',
          storeNamePlaceholder: 'Amazon, AliExpress, ...',
          cargoIdCode: 'Код Cargo ID',
          cargoIdCodePlaceholder: 'T10001',
          address: 'Адрес',
          addressPlaceholder: 'Адрес доставки',
        },
        fio: {
          label: 'ФИО',
          loading: 'Поиск…',
          notFound: 'Не найдено',
          empty: 'Введите код Cargo ID',
        },
        errors: {
          trekIdRequired: 'Trek ID обязателен',
          tooLong: 'Слишком длинно',
          invalidNumber: 'Неверное значение',
          cargoIdNotFound: 'Код Cargo ID не найден',
        },
      },
      formPage: {
        createTitle: 'Добавить бесхозную посылку',
        editTitle: 'Редактировать бесхозную посылку',
        notFound: 'Посылка не найдена',
        loadError: 'Не удалось загрузить посылку',
      },
      scanner: {
        title: 'Сканирование',
        titleOnly: 'Сканируйте Trek ID',
        close: 'Закрыть',
        toast: {
          added: '{{trekId}} добавлено',
          duplicate: '{{trekId}} уже добавлено',
          wait: 'Пожалуйста, подождите',
        },
      },
      delete: {
        title: 'Удалить посылку',
        description: 'Удалить посылку {{trekId}}?',
        confirm: 'Удалить',
        toast: {
          deleted: 'Посылка удалена',
        },
      },
      toast: {
        created: 'Посылка добавлена',
        updated: 'Посылка обновлена',
        duplicateTrekId: 'Бесхозная посылка с этим трек ID уже существует',
      },
    },
    warehouseArrivals: {
      tabs: { packages: 'Прибывшие пакеты', parcels: 'Прибывшие посылки' },
      packages: {
        searchPlaceholder: 'Поиск по названию или ID',
        scan: 'Сканировать',
        view: 'Просмотр',
        deliveredToCustomer: 'Доставлено клиенту',
        delivered: { yes: 'Да', no: 'Нет' },
        emptyTitle: 'Пакеты не найдены',
        emptyDescription: 'Измените условия фильтра.',
        loadError: 'Не удалось загрузить пакеты',
        columns: { name: 'Название', uniqueId: 'Уникальный ID', party: 'Партия', parcels: 'Посылки', delivered: 'Доставлено клиенту', actions: 'Действия' },
        toast: { delivered: 'Статус обновлён' },
        confirm: {
          markTitle: 'Отметить как доставлено клиенту',
          markDescription: 'Отметить эту посылку как доставленную клиенту?',
          markConfirm: 'Да, доставлено',
          cancelTitle: 'Отменить доставку',
          cancelDescription: 'Отменить статус «доставлено» для этой посылки?',
          cancelConfirm: 'Да, отменить',
          dismiss: 'Закрыть',
        },
        viewTitle: 'Информация о пакете',
        notFound: 'Пакет не найден',
        loadDetailError: 'Не удалось загрузить пакет',
        fields: { name: 'Название', uniqueId: 'Уникальный ID', party: 'Партия', price: 'Цена', weight: 'Вес', parcels: 'Посылки' },
      },
      parcels: {
        searchPlaceholder: 'Поиск по трек ID или названию',
        view: 'Просмотр',
        emptyTitle: 'Посылки не найдены',
        emptyDescription: 'Измените условия фильтра.',
        loadError: 'Не удалось загрузить посылки',
        delivered: { yes: 'Да', no: 'Нет' },
        columns: { name: 'Название', trekId: 'Трек ID', pinfl: 'ПИНФЛ', delivered: 'Доставлено клиенту', split: 'Разделение', actions: 'Действия' },
        viewTitle: 'Информация о посылке',
        notFound: 'Посылка не найдена',
        loadDetailError: 'Не удалось загрузить посылку',
        fields: { name: 'Название', trekId: 'Трек ID', pinfl: 'ПИНФЛ', delivered: 'Доставлено клиенту', split: 'Разделение' },
      },
      scan: {
        title: 'Сканируйте',
        placeholder: 'Отсканируйте или введите уникальный ID',
        submit: 'Подтвердить',
        close: 'Закрыть',
        notArrived: 'Этот пакет ещё не прибыл',
        notFound: 'Пакет не найден',
        scanning: 'Сканируйте...',
      },
    },
    packages: {
      list: {
        title: 'Пакеты',
        subtitle: 'Управление пакетами',
        newPackage: 'Новый пакет',
        searchPlaceholder: 'Поиск по названию',
        emptyTitle: 'Пакеты не найдены',
        emptyDescription: 'Создайте пакет или измените фильтр.',
        loadError: 'Не удалось загрузить пакеты',
        columns: {
          name: 'Название',
          price: 'Цена',
          weight: 'Вес',
          parcelsCount: 'Кол-во посылок',
          createdAt: 'Дата',
          actions: 'Действия',
        },
      },
      form: {
        createTitle: 'Новый пакет',
        editTitle: 'Редактировать пакет',
        notFound: 'Пакет не найден',
        loadError: 'Не удалось загрузить пакет',
        fields: {
          name: 'Название',
          uniqueId: 'Уникальный ID',
          price: 'Цена',
          weight: 'Вес',
          weightUnit: 'Единица веса',
        },
        generate: 'Сгенерировать',
        downloadQr: 'Скачать QR',
        weightUnit: {
          kg: 'кг',
          g: 'г',
        },
        errors: {
          nameRequired: 'Название обязательно',
          invalidNumber: 'Неверное значение',
          tooLong: 'Слишком длинно',
          parcelsRequired: 'Добавьте хотя бы одну посылку',
        },
      },
      columns: {
        productName: 'Наименование товара',
        quantity: 'Кол-во',
        unitPrice: 'Цена за 1',
        totalPrice: 'Общая цена',
        trekId: 'Trek ID',
        cargoId: 'Cargo ID',
        passport: 'Паспорт',
        pinfl: 'ПИНФЛ',
        date: 'Дата',
        actions: 'Действия',
        parcelName: 'Название посылки',
        products: 'Товары',
      },
      parcelPicker: {
        title: 'Посылки',
        subtitle: 'Прикрепленные посылки: {{count}}',
        addBtn: 'Добавить посылку',
        emptyAttached: 'Пока нет прикрепленных посылок',
        selectedEmpty: 'Посылки не выбраны',
        filters: {
          trekId: 'Поиск по Trek ID',
          name: 'Поиск по названию товара',
          cargoId: 'Поиск по Cargo ID',
        },
        dialog: {
          title: 'Добавить посылку',
          searchPlaceholder: 'Поиск по Trek ID / товару / Cargo ID',
          emptyTitle: 'Подходящих посылок не найдено',
          emptyDescription: 'Попробуйте другой запрос.',
          loadError: 'Не удалось загрузить посылки',
          addRow: 'Добавить',
          alreadyAdded: 'Добавлено',
          productSingle: '{{name}} × {{qty}}',
          productSummary: '{{name}} × {{qty}} (+{{extra}})',
        },
      },
      delete: {
        title: 'Удалить пакет',
        description: 'Удалить пакет «{{name}}»?',
        confirm: 'Удалить',
      },
      toasts: {
        created: 'Пакет создан',
        updated: 'Пакет обновлен',
        deleted: 'Пакет удален',
      },
    },
    categories: {
      list: {
        title: 'Категории',
        subtitle: 'Категории и подкатегории товаров',
        newCategory: 'Новая категория',
        loadError: 'Не удалось загрузить категории',
        emptyTitle: 'Категорий пока нет',
        emptyDescription: 'Создайте новую категорию и добавьте к ней подкатегории.',
        subcategoriesCount: '{{count}} подкат.',
        emptySubcategories: 'Подкатегорий пока нет',
        expand: 'Раскрыть',
        collapse: 'Свернуть',
        addSubcategory: 'Добавить подкатегорию',
      },
      form: {
        createTitle: 'Новая категория',
        editTitle: 'Редактирование категории',
        description: 'Введите название категории на 3 языках.',
        nameUz: 'Название (UZ)',
        nameRu: 'Название (RU)',
        nameEn: 'Название (EN)',
        nameKk: 'Название (KK)',
        errors: {
          nameUzRequired: 'Введите название на узбекском',
          nameRuRequired: 'Введите название на русском',
          nameEnRequired: 'Введите название на английском',
          tooLong: 'Слишком длинно',
        },
      },
      subcategory: {
        createTitle: 'Новая подкатегория',
        editTitle: 'Редактирование подкатегории',
      },
      confirmDelete: {
        title: 'Удаление категории',
        description: 'Категория "{{name}}" будет удалена вместе со всеми подкатегориями.',
        confirm: 'Удалить',
      },
      confirmDeleteSub: {
        title: 'Удаление подкатегории',
        description: 'Удалить "{{name}}"?',
        confirm: 'Удалить',
      },
      toast: {
        created: 'Категория создана',
        updated: 'Категория обновлена',
        deleted: 'Категория удалена',
        subCreated: 'Подкатегория добавлена',
        subUpdated: 'Подкатегория обновлена',
        subDeleted: 'Подкатегория удалена',
      },
      reassign: {
        title: 'Перемещение товаров',
        catDescription:
          'Категория «{{name}}» используется в товарах. Перед удалением переместите товары в другую категорию.',
        subDescription:
          'Подкатегория «{{name}}» используется в товарах. Перед удалением переместите товары в другую подкатегорию.',
        catLabel: 'Новая категория',
        subLabel: 'Новая подкатегория',
        placeholder: 'Выберите',
        confirm: 'Переместить и удалить',
        catNoTargets: 'Нет другой категории для перемещения. Сначала создайте категорию.',
        subNoTargets: 'Нет другой подкатегории для перемещения. Сначала создайте подкатегорию.',
      },
    },
    staff: {
      list: {
        title: 'Сотрудники',
        subtitle: 'Пользователи с правом входа в систему',
        newStaff: 'Новый сотрудник',
        searchPlaceholder: 'По имени, username или телефону',
        loadError: 'Не удалось загрузить сотрудников',
        emptyTitle: 'Сотрудников пока нет',
        active: 'Активен',
        inactive: 'Неактивен',
        activate: 'Активировать',
        deactivate: 'Деактивировать',
        superBadge: 'Суперсотрудник',
        columns: {
          fullName: 'ФИО',
          username: 'Username',
          phone: 'Телефон',
          role: 'Роль',
          status: 'Статус',
          createdAt: 'Создан',
          actions: 'Действия',
        },
      },
      formPage: {
        createTitle: 'Новый сотрудник',
        editTitle: 'Редактировать сотрудника',
        notFound: 'Сотрудник не найден.',
        loadError: 'Не удалось загрузить сотрудника',
        superNote: 'Это суперсотрудник — роль назначить нельзя',
      },
      form: {
        title: 'Новый сотрудник',
        description: 'Создайте учётную запись сотрудника. Пароль показывается один раз — сохраните его.',
        submit: 'Создать',
        fields: {
          fullName: 'ФИО',
          username: 'Username',
          password: 'Пароль',
          passwordOptional: 'Новый пароль (необязательно)',
          passwordEditPlaceholder: 'Оставьте пустым, чтобы не менять',
          phone: 'Телефон (необязательно)',
          phonePlaceholder: '+998901234567',
          role: 'Роль',
          rolePlaceholder: 'Выберите роль',
        },
        errors: {
          fullNameRequired: 'ФИО обязательно',
          usernameMin: 'Username минимум 3 символа',
          usernameInvalid: 'Только латиница, цифры, _ . -',
          passwordMin: 'Пароль минимум 6 символов',
          tooLong: 'Слишком длинно',
          roleRequired: 'Выберите роль',
          rolesLoadFailed: 'Не удалось загрузить роли',
        },
      },
      confirmDelete: {
        title: 'Удаление сотрудника',
        description: 'Учётная запись "{{name}}" будет полностью удалена.',
        confirm: 'Удалить',
      },
      confirmToggle: {
        deactivate: {
          title: 'Деактивация сотрудника',
          description: 'Учётная запись "{{name}}" будет деактивирована — сотрудник не сможет войти в систему. Продолжить?',
          confirm: 'Да, деактивировать',
        },
        activate: {
          title: 'Активация сотрудника',
          description: 'Учётная запись "{{name}}" будет снова активирована, и сотрудник сможет войти в систему.',
          confirm: 'Да, активировать',
        },
      },
      toast: {
        created: 'Сотрудник создан',
        updated: 'Сотрудник обновлён',
        deleted: 'Сотрудник удалён',
        activated: 'Сотрудник активирован',
        deactivated: 'Сотрудник деактивирован',
      },
    },
    supportStaff: {
      list: {
        title: 'Технический помощник',
        subtitle: 'Специалисты, помогающие клиентам',
        emptyTitle: 'Помощников пока нет',
        loadError: 'Не удалось загрузить помощников',
        yearsSuffix: '{{count}} лет',
        create: 'Новый помощник',
        columns: {
          image: 'Фото',
          name: 'Имя',
          contact: 'Ссылка для связи',
          languages: 'Языки',
          experience: 'Стаж работы (лет)',
          createdAt: 'Создан',
          actions: 'Действия',
        },
      },
      form: {
        createTitle: 'Новый помощник',
        editTitle: 'Редактировать помощника',
        description: 'Введите данные помощника.',
        fields: {
          name: 'Имя',
          contact: 'Ссылка для связи',
          languages: 'Языки',
          experience: 'Стаж работы (лет)',
          image: 'Фото',
          pickImage: 'Выбрать фото',
          languagesPlaceholder: 'Введите язык и добавьте',
          addLanguage: 'Добавить',
        },
        errors: {
          nameRequired: 'Имя обязательно',
          tooLong: 'Слишком длинно',
          contactRequired: 'Ссылка для связи обязательна',
          contactInvalid: 'Некорректная ссылка',
          languagesRequired: 'Добавьте хотя бы один язык',
          experienceMin: 'Стаж не может быть меньше 0',
          imageType: 'Только файл изображения',
          imageTooLarge: 'Размер изображения слишком большой',
        },
        notFound: 'Сотрудник не найден',
      },
      toast: {
        created: 'Помощник добавлен',
        updated: 'Помощник обновлён',
        deleted: 'Помощник удалён',
      },
      confirmDelete: {
        title: 'Удаление помощника',
        description: 'Удалить "{{name}}"?',
        confirm: 'Удалить',
      },
    },
    faqs: {
      list: {
        title: 'Вопросы и ответы',
        subtitle: 'Часто задаваемые вопросы для клиентов',
        newFaq: 'Новый вопрос',
        loadError: 'Не удалось загрузить вопросы',
        emptyTitle: 'Пока нет вопросов',
        emptyDescription: 'Добавьте первый вопрос.',
        active: 'Активен',
        inactive: 'Неактивен',
        activate: 'Активировать',
        deactivate: 'Деактивировать',
      },
      form: {
        createTitle: 'Новый вопрос',
        editTitle: 'Редактировать вопрос',
        description: 'Введите вопрос и ответ на 3 языках.',
        questionUz: 'Вопрос (UZ)',
        questionRu: 'Вопрос (RU)',
        questionEn: 'Вопрос (EN)',
        questionKk: 'Вопрос (KK)',
        answerUz: 'Ответ (UZ)',
        answerRu: 'Ответ (RU)',
        answerEn: 'Ответ (EN)',
        answerKk: 'Ответ (KK)',
        order: 'Порядок',
        isActive: 'Активен',
        errors: {
          required: 'Обязательное поле',
          tooLong: 'Слишком длинно',
          order: 'Порядок должен быть не меньше 0',
        },
      },
      confirmDelete: {
        title: 'Удалить вопрос',
        description: 'Удалить "{{name}}"?',
        confirm: 'Удалить',
      },
      confirmToggle: {
        activateTitle: 'Активировать вопрос',
        activateDescription: 'Активировать "{{name}}"?',
        activateConfirm: 'Активировать',
        deactivateTitle: 'Деактивировать вопрос',
        deactivateDescription: 'Деактивировать "{{name}}"?',
        deactivateConfirm: 'Деактивировать',
      },
      toast: {
        created: 'Вопрос добавлен',
        updated: 'Вопрос обновлён',
        deleted: 'Вопрос удалён',
        activated: 'Вопрос активирован',
        deactivated: 'Вопрос деактивирован',
      },
    },
    support: {
      list: {
        title: 'Поддержка',
        subtitle: 'Переписка с клиентами',
        searchPlaceholder: 'По email или имени',
        loadError: 'Не удалось загрузить переписки',
        emptyTitle: 'Пока нет переписок',
        emptyDescription: 'Здесь появятся сообщения клиентов.',
        blocked: 'Заблокирован',
      },
      chat: {
        title: 'Переписка',
        loadError: 'Не удалось загрузить переписку',
        emptyTitle: 'Нет сообщений',
        emptyDescription: 'Отправьте первое сообщение.',
        messagePlaceholder: 'Напишите сообщение…',
        send: 'Отправить',
        attach: 'Прикрепить файл',
        file: 'Файл',
        fileTooLarge: 'Размер файла не должен превышать 10 МБ',
        block: 'Заблокировать',
        unblock: 'Разблокировать',
        blockedState: 'Заблокирован',
        confirmBlock: {
          title: 'Заблокировать клиента',
          description: '"{{name}}" будет заблокирован и не сможет писать вам. Продолжить?',
          confirm: 'Да, заблокировать',
        },
        toast: {
          blocked: 'Клиент заблокирован',
          unblocked: 'Клиент разблокирован',
        },
        info: {
          email: 'Email',
          name: 'Имя',
          phone: 'Телефон',
          languages: 'Языки',
        },
      },
    },
    limitConfig: {
      title: 'Настройка лимита PINFL',
      subtitle: 'Управляйте лимитом расходов клиентов и периодом его обновления',
      loadError: 'Не удалось загрузить настройку',
      updatedAt: 'Последнее обновление: {{date}}',
      form: {
        amountSection: 'Размер лимита',
        cadenceSection: 'Период обновления',
        cadenceDescription: 'Лимит сбрасывается каждые N дней или каждые N месяцев',
        resetSection: 'Текущие расходы',
        submit: 'Сохранить',
        periodUnit: {
          DAY: 'Дни',
          MONTH: 'Месяцы',
        },
        fields: {
          amount: 'Размер лимита (USD)',
          periodUnit: 'Единица периода',
          periodValueDay: 'Каждые сколько дней',
          periodValueMonth: 'Каждые сколько месяцев',
          startDay: 'День обновления в месяце',
          startDate: 'Дата начала',
          timezone: 'Часовой пояс',
          resetUsage: 'Сбросить расходы клиентов при изменении лимита',
        },
        hints: {
          amount: 'Максимальная сумма, которую клиент может потратить за период.',
          startDay: 'Если день 29–31, а в месяце его нет (например, в феврале), обновление переносится на 1-е число следующего месяца.',
          startDate: 'Дневной период отсчитывается от этой даты.',
          resetUsageOn: 'Израсходованные суммы всех клиентов будут сброшены до 0.',
          resetUsageOff: 'Клиенты сохранят свои расходы. Если новый лимит ниже, некоторые клиенты могут оказаться сверх лимита.',
        },
        errors: {
          amountInvalid: 'Некорректное значение',
          amountMin: 'Не может быть отрицательным',
          periodValueInvalid: 'Введите целое число',
          periodValueMin: 'Минимум 1',
          startDayInvalid: 'Введите целое число',
          startDayRange: 'День от 1 до 31',
          timezoneRequired: 'Выберите часовой пояс',
        },
      },
      toast: {
        saved: 'Настройка лимита сохранена',
      },
    },
    pricing: {
      title: 'Цены',
      subtitle: 'Лимит и цены услуг',
      loadError: 'Не удалось загрузить цены',
      limitSection: 'Настройка лимита',
      pricingSection: 'Цены услуг',
      fields: {
        limit: 'Лимит',
        splitFee: 'Цена разделения',
        packagePricePerKg: 'Цена пакета (кг)',
        photoFee: 'Цена фото',
        videoFee: 'Цена видео',
        proverkaFee: 'Цена проверки',
        returnFee: 'Цена возврата',
      },
      toast: {
        savedLimit: 'Лимит сохранён',
        savedPricing: 'Цены сохранены',
      },
      save: 'Сохранить',
    },
    serviceReports: {
      photo: {
        title: 'Фото-отчёты',
        subtitle: 'Запросы фото от клиентов',
      },
      video: {
        title: 'Видео-отчёты',
        subtitle: 'Запросы видео от клиентов',
      },
      proverka: {
        title: 'Отчёты по проверке',
        subtitle: 'Запросы клиентов на проверку',
      },
      columns: {
        parcel: 'Посылка',
        contact: 'Контакт',
        note: 'Заметка',
        fee: 'Цена',
        status: 'Статус',
        createdAt: 'Дата',
        actions: 'Действие',
      },
      filter: {
        all: 'Все',
        pending: 'Ожидание',
        done: 'Отправлено',
      },
      markDone: 'Отправлено',
      cancel: 'Отменить',
      cancelTitle: 'Отмена запроса',
      cancelDescription: 'Отменить этот запрос для посылки «{{name}}»? Начисленная оплата также будет отменена, и клиент сможет отправить запрос повторно.',
      cancelConfirm: 'Да, отменить',
      markDoneTitle: 'Отметить как отправлено',
      markDoneDescription: 'Отметить этот запрос для посылки «{{name}}» как отправленный клиенту?',
      markDoneConfirm: 'Да, отправлено',
      emptyTitle: 'Нет отчётов',
      emptyDescription: 'Пока нет запросов',
      loadError: 'Не удалось загрузить отчёты',
      status: {
        cancelled: 'Отменён',
      },
      toast: {
        done: 'Отмечено как отправлено',
        cancelled: 'Отменено',
      },
    },
    returns: {
      title: 'Возвраты',
      subtitle: 'Запросы клиентов на возврат',
      columns: {
        parcel: 'Посылка',
        note: 'Заметка',
        fee: 'Цена',
        status: 'Статус',
        createdAt: 'Дата',
        actions: 'Действие',
      },
      status: {
        pending: 'Ожидание',
        confirmed: 'Подтверждён',
        rejected: 'Отклонён',
        cancelled: 'Отменён',
      },
      confirm: 'Подтвердить',
      reject: 'Отклонить',
      cancel: 'Отменить',
      confirmTitle: 'Подтверждение возврата',
      confirmDescription: 'Подтвердить этот запрос на возврат для посылки «{{name}}»?',
      confirmConfirm: 'Да, подтвердить',
      rejectTitle: 'Отклонение возврата',
      rejectDescription: 'Отклонить этот запрос на возврат для посылки «{{name}}»?',
      rejectReasonLabel: 'Причина отклонения',
      rejectReasonPlaceholder: 'Укажите причину (необязательно)',
      rejectConfirm: 'Да, отклонить',
      cancelTitle: 'Отмена возврата',
      cancelDescription: 'Отменить этот запрос на возврат для посылки «{{name}}»? Начисленная оплата также будет отменена, и клиент сможет отправить запрос повторно.',
      cancelConfirm: 'Да, отменить',
      filter: {
        all: 'Все',
        pending: 'Ожидание',
        confirmed: 'Подтверждённые',
        rejected: 'Отклонённые',
      },
      toast: {
        confirmed: 'Подтверждено',
        rejected: 'Отклонено',
        cancelled: 'Отменено',
      },
      loadError: 'Не удалось загрузить возвраты',
      emptyTitle: 'Нет возвратов',
      emptyDescription: 'Пока нет запросов',
    },
    clients: {
      empty: 'Нет данных',
      list: {
        title: 'Клиенты',
        subtitle: 'Зарегистрированные клиенты',
        searchPlaceholder: 'Поиск по email или имени',
        loadError: 'Не удалось загрузить клиентов',
        emptyTitle: 'Клиентов пока нет',
        emptyDescription: 'Измените условия поиска.',
        columns: {
          email: 'Email',
          fullName: 'ФИО',
          phone: 'Телефон',
          limit: 'Лимит',
          status: 'Статус',
          createdAt: 'Дата регистрации',
          actions: 'Действия',
        },
        actions: {
          view: 'Просмотр',
        },
        status: {
          active: 'Активен',
          blocked: 'Заблокирован',
        },
      },
      detail: {
        subtitle: 'Данные клиента',
        notFound: 'Клиент не найден',
        infoSection: 'Личные данные',
        fields: {
          firstName: 'Имя',
          lastName: 'Фамилия',
          email: 'Email',
          phone: 'Телефон',
          languages: 'Языки',
          createdAt: 'Дата регистрации',
        },
      },
      block: {
        blockButton: 'Заблокировать создание посылок',
        unblockButton: 'Разблокировать',
        blockTitle: 'Заблокировать создание посылок',
        blockDescription: 'Клиент потеряет возможность создавать посылки. Продолжить?',
        unblockTitle: 'Разблокировать',
        unblockDescription: 'Клиенту будет возвращена возможность создавать посылки. Продолжить?',
        confirm: 'Подтвердить',
        cancel: 'Отмена',
        toastBlocked: 'Клиенту запрещено создавать посылки',
        toastUnblocked: 'Клиент разблокирован',
      },
      claimedTrekIds: {
        title: 'Закреплённые Trek ID',
        columns: {
          trekId: 'Trek ID',
          parcelStatus: 'Статус посылки',
          fulfillmentStatus: 'Исполнение',
          partyStatus: 'Статус партии',
          cargoIdCode: 'Cargo ID',
          createdAt: 'Дата',
        },
        empty: 'Пока нет',
        loadError: 'Не удалось загрузить Trek ID',
      },
      receipts: {
        title: 'История платежей',
        columns: {
          number: 'Номер чека',
          parcel: 'Посылка',
          amount: 'Сумма',
          createdAt: 'Дата',
          actions: 'Действия',
        },
        view: 'Просмотр',
        pdf: 'PDF',
        empty: 'Платежей нет',
        loadError: 'Не удалось загрузить историю платежей',
      },
    },
    broadcast: {
      title: 'Отправить объявление',
      subtitle: 'Отправьте уведомление всем клиентам',
      form: {
        textSection: 'Текст объявления',
        textHint: 'Текст будет отправлен всем клиентам в виде уведомления.',
        imageSection: 'Изображение (необязательно)',
        imageHint: 'К объявлению можно прикрепить изображение (максимум 10 МБ).',
        pickImage: 'Выбрать изображение',
        submit: 'Отправить',
        fields: {
          textUz: 'Сообщение (uz)',
          textUzPlaceholder: 'Введите текст объявления…',
          textRu: 'Сообщение (ru)',
          textRuPlaceholder: 'Введите текст объявления на русском…',
          textEn: 'Сообщение (en)',
          textEnPlaceholder: 'Введите текст объявления на английском…',
          textKk: 'Сообщение (kk)',
          textKkPlaceholder: 'Введите текст объявления на казахском…',
          textKkHint: 'Если оставить пустым, казахоязычным клиентам будет показан русский текст.',
        },
        errors: {
          textRequired: 'Текст обязателен',
          tooLong: 'Слишком длинно',
          imageType: 'Только файлы изображений',
          imageTooLarge: 'Размер изображения не должен превышать 10 МБ',
        },
      },
      toast: {
        sent: 'Объявление отправлено {{count}} клиентам',
      },
    },
    splits: {
      list: {
        title: 'Разделения',
        subtitle: 'Разделение посылок между получателями',
        searchPlaceholder: 'Поиск по трек-номеру',
        loadError: 'Не удалось загрузить разделения',
        emptyTitle: 'Разделения не найдены',
        emptyDescription: 'Пока нет разделений',
        columns: {
          trekId: 'Трек',
          parcel: 'Посылка',
          status: 'Статус',
          targets: 'Получатели',
          total: 'Итого',
          createdAt: 'Создано',
          actions: 'Действия',
        },
      },
      status: {
        DRAFT: 'Черновик',
        IN_PROGRESS: 'В процессе',
        DELIVERED: 'Доставлено',
        RESERVED: 'Зарезервировано',
        DISTRIBUTED: 'Распределено',
        CONFIRMED: 'Подтверждено',
        CANCELLED: 'Отменено',
      },
      detail: {
        trek: 'Трек-номер: {{trek}}',
        notFound: 'Разделение не найдено',
        loadError: 'Не удалось загрузить разделение',
        sections: {
          parcel: 'Исходная посылка',
          targets: 'Получатели',
          allocation: 'Распределение',
        },
        parcel: {
          trekId: 'Трек',
          name: 'Название',
          pinfl: 'ПИНФЛ',
          serviceFee: 'Сервисный сбор',
          total: 'Общая сумма',
        },
        target: {
          recipient: 'Получатель',
          pinfl: 'ПИНФЛ',
          address: 'Адрес',
          reserved: 'Зарезервировано',
          total: 'Итого',
          package: 'Пакет',
        },
        allocation: {
          product: 'Товар',
          quantity: 'Кол-во',
          amount: 'Сумма',
          total: 'Итого',
          empty: 'Нет распределения',
        },
        statusNote: {
          CANCELLED: 'Это разделение отменено',
          RESERVED: 'Это разделение зарезервировано',
        },
      },
      distribute: {
        title: 'Распределение товаров',
        hint: 'Распределите каждый товар между получателями',
        productHeader: 'Товар',
        totalQty: 'Доступно',
        unitPrice: 'Цена',
        remaining: 'Остаток',
        targetTotal: 'Итого',
        overLimit: 'Превышен лимит',
        submit: 'Распределить',
        errors: {
          overAllocated: 'Распределённое количество превышает доступное',
          pinflLimit: 'Лимит ПИНФЛ {{pinfl}} недостаточен',
        },
        success: 'Распределено',
      },
      confirm: {
        button: 'Подтвердить',
        confirmTitle: 'Подтверждение разделения',
        confirmDescription: 'Для каждого получателя будет создан пакет. Продолжить?',
        confirmAction: 'Подтвердить',
        success: 'Пакеты созданы',
      },
      cancel: {
        button: 'Отменить',
        confirmTitle: 'Отмена разделения',
        confirmDescription: 'Разделение будет отменено, а резервы возвращены. Продолжить?',
        confirmAction: 'Отменить',
        success: 'Разделение отменено',
      },
      empty: {
        products: 'Нет товаров',
        targets: 'Нет получателей',
        allocations: 'Нет распределения',
      },
      save: {
        title: 'Сохранить',
        sections: {
          products: 'Товары',
          recipients: 'ПИНФЛ (получатели)',
          serviceFee: 'Сервисный сбор',
        },
        product: {
          name: 'Название товара',
          quantity: 'Кол-во',
          unitPrice: 'Цена',
        },
        recipient: {
          title: 'Получатель',
          pinfl: 'ПИНФЛ',
          firstName: 'Имя',
          lastName: 'Фамилия',
          middleName: 'Отчество',
          phone: 'Телефон',
          passport: 'Серия паспорта',
          addressName: 'Название адреса',
          region: 'Регион',
          city: 'Город/район',
          street: 'Улица',
          building: 'Дом',
          apartment: 'Квартира',
          additionalInfo: 'Доп. информация',
        },
        package: {
          name: 'Название пакета',
          price: 'Цена пакета',
          priceOptional: 'Цена пакета (необязательно)',
          priceHint: 'Если пусто — рассчитается по весу',
          weight: 'Вес',
          weightUnit: 'Ед. веса',
          uniqueId: 'Уникальный ID',
        },
        allocations: {
          title: 'Товары',
          product: 'Товар',
          quantity: 'Кол-во',
          addProduct: 'Добавить товар',
          removeProduct: 'Удалить',
          selectPlaceholder: 'Выберите товар',
          empty: 'Нет товаров',
        },
        limit: {
          label: 'Лимит',
          value: '{{used}} / {{ceiling}}',
        },
        addPinfl: 'Добавить ПИНФЛ',
        removePinfl: 'Удалить ПИНФЛ',
        expand: 'Открыть',
        collapse: 'Закрыть',
        serviceFeeLabel: 'Сервисный сбор',
        generate: 'Сгенерировать',
        downloadQr: 'Скачать QR',
        serviceFeeComputed: 'Итого сервисный сбор: {{total}} ({{count}} × {{fee}})',
        submit: 'Сохранить',
        delete: 'Удалить',
        deleteConfirmTitle: 'Удалить разделение',
        deleteConfirmDescription: 'Это разделение будет удалено навсегда. Продолжить?',
        readOnlyNote: 'Это разделение нельзя редактировать',
        success: 'Сохранено',
        deleteSuccess: 'Разделение удалено',
        errors: {
          exceedsAvailable: 'Превышает доступное количество',
          saveFailed: 'Не удалось сохранить',
          pinflRequired: 'ПИНФЛ обязателен',
          distributionExact: 'Следующие товары распределены не полностью: {{products}}',
        },
      },
    },
    },
  },
  en: {
    translation: {
    common: {
      language: 'Language',
      uzbek: 'Uzbek',
      russian: 'Russian',
      english: 'English',
      required: 'Required',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      errorGeneric: 'Something went wrong',
      retry: 'Retry',
      loading: 'Loading…',
      noData: 'No data',
      noAccessTitle: 'No access',
      noAccessDescription: 'You do not have permission for this section.',
    },
    ui: {
      nothingFound: 'Nothing found',
      searchPlaceholder: 'Search…',
      prevPage: 'Previous page',
      nextPage: 'Next page',
      close: 'Close',
      menu: 'Menu',
      back: 'Back',
    },
    errorBoundary: {
      title: 'Something went wrong',
      description: 'Please try again. If the problem persists, return to the home page.',
      retry: 'Retry',
      goHome: 'Go to home page',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'System overview',
      errorLoad: 'Failed to load dashboard',
      stats: {
        totalParcels: 'Total parcels',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        parties: 'Parties',
        clients: 'Clients',
      },
      chart: {
        monthlyTitle: 'Parcels by month',
        monthlySubtitle: 'New parcels in the last 6 months',
        partiesTitle: 'Party statuses',
        partiesSubtitle: 'Distribution of current parties',
      },
    },
    regions: {
      TASHKENT_CITY: 'Tashkent City',
      TASHKENT: 'Tashkent Region',
      FERGANA: 'Fergana',
      ANDIJAN: 'Andijan',
      NAMANGAN: 'Namangan',
      SAMARKAND: 'Samarkand',
      BUKHARA: 'Bukhara',
      SIRDARYA: 'Sirdaryo',
      SURKHANDARYA: 'Surkhandarya',
      NAVOI: 'Navoi',
      QASHQADARYA: 'Kashkadarya',
      KHOREZM: 'Khorezm',
      JIZZAKH: 'Jizzakh',
      KARAKALPAKSTAN: 'Karakalpakstan',
      XIVA: 'Khiva',
    },
    notFound: {
      title: 'Page not found',
      description: "The page you're looking for doesn't exist or has been removed.",
      goHome: 'Go home',
    },
    login: {
      title: 'Sign in',
      username: 'Username',
      password: 'Password',
      submit: 'Sign in',
      toastWelcome: 'Welcome!',
      errors: {
        usernameRequired: 'Username is required',
        passwordRequired: 'Password is required',
        tooLong: 'Too long',
        invalidCredentials: 'Invalid username or password',
        generic: 'Sign-in failed',
      },
    },
    topbar: {
      user: {
        fallback: 'User',
        owner: 'Owner',
      },
      menu: {
        logout: 'Sign out',
      },
      toast: {
        signedOut: 'Signed out',
      },
    },
    header: {
      user: 'User',
      superLabel: 'Super staff',
    },
    nav: {
      dashboard: 'Dashboard',
      parcels: 'Parcels',
      parties: 'Parties',
      packages: 'Packages',
      splits: 'Splits',
      cargoIds: 'Cargo ID',
      warehouse: 'Warehouse',
      categories: 'Categories',
      staff: 'Staff',
      roles: 'Roles',
      clients: 'Clients',
      legacyClients: 'Old clients',
      support: 'Support',
      supportStaff: 'Support staff',
      broadcast: 'Send announcement',
      faqs: 'FAQ',
      limitConfig: 'Limit settings',
      pricing: 'Prices',
      unreadTooltip: '{{count}} unread messages',
      splitsPendingTooltip: '{{count}} draft splits',
      reportsPhoto: 'Photo reports',
      reportsVideo: 'Video reports',
      reportsPhotoPendingTooltip: '{{count}} pending photo requests',
      reportsVideoPendingTooltip: '{{count}} pending video requests',
      reportsProverka: 'Inspections',
      reportsProverkaPendingTooltip: '{{count}} pending inspection requests',
      returns: 'Returns',
      returnsPendingTooltip: '{{count}} pending returns',
    },
    userStatus: {
      ghost: 'Guest',
      user: 'User',
      admin: 'Admin',
    },
    legacyClients: {
      list: {
        title: 'Old clients',
        subtitle: 'Clients imported from the old system',
        searchPlaceholder: 'Search by name, phone, Cargo ID or username',
        emptyTitle: 'No old clients found',
        emptyDescription: 'Adjust the search conditions.',
        loadError: 'Failed to load old clients',
        columns: {
          cargoIdCode: 'Cargo ID',
          fullName: 'Full name',
          phone: 'Phone',
          username: 'Username',
          telegramName: 'Telegram name',
          formCount: 'Forms',
          userStatus: 'Status',
          createdAt: 'Created',
        },
      },
    },
    roles: {
      OWNER: 'Super Admin',
      JAPAN_WORKER: 'Japan worker',
      UZBEK_WORKER: 'Uzbek worker',
      list: {
        title: 'Roles',
        subtitle: 'Manage user roles and permissions',
        newRole: 'New role',
        loadError: 'Failed to load roles',
        emptyTitle: 'No roles yet',
        superBadge: 'Super',
        customBadge: 'Custom',
        columns: {
          name: 'Name',
          kind: 'Type',
          permissions: 'Permissions',
          staffCount: 'Staff',
          createdAt: 'Created',
          actions: 'Actions',
        },
      },
      create: {
        title: 'New role',
        description: 'Name the role and select the permissions it should have.',
        submit: 'Create',
      },
      edit: {
        title: 'Edit role',
        superTitle: 'View super role',
        description: 'Update the role name and permissions.',
        submit: 'Save',
      },
      formPage: {
        createTitle: 'New role',
        editTitle: 'Edit role',
        notFound: 'Role not found.',
        loadError: 'Failed to load the role',
      },
      delete: {
        title: 'Delete role',
        description: 'Delete the "{{name}}" role? First reassign all staff to another role.',
        reassignLabel: 'Reassign staff to',
        reassignHint: 'All staff in this role will be moved to the selected role, then the role will be deleted.',
        staffWarning: '{{count}} staff currently use this role. They will all be reassigned.',
        noTargets: 'No other roles available. Create a new role first.',
        confirm: 'Delete',
      },
      form: {
        fields: {
          name: 'Role name',
          permissions: 'Permissions',
        },
        errors: {
          nameRequired: 'Role name is required',
          tooLong: 'Too long',
        },
      },
      treePicker: {
        selectAll: 'Select all',
        selectedCount: 'Selected: {{count}} / {{total}}',
        loadError: 'Failed to load the permissions registry',
        nodes: {
          dashboard: 'Dashboard',
          parcels: 'Parcels',
          cargo_ids: 'Cargo ID',
          parties: 'Parties',
          warehouse: 'Warehouse',
          clients: 'Clients',
          staff: 'Staff',
          roles: 'Roles',
          categories: 'Categories',
          faqs: 'FAQ',
          broadcast: 'Broadcast',
          support: 'Support',
          view: 'View',
          list: 'List',
          detail: 'Detail',
          create: 'Create',
          update: 'Update',
          edit: 'Edit',
          delete: 'Delete',
          column: 'Column',
          filter: 'Filter',
          approve: 'Approve',
          reject: 'Reject',
          export: 'Export',
          manage: 'Manage',
          scan: 'Scan',
          block: 'Block',
          unblock: 'Unblock',
          respond: 'Respond',
          send: 'Send',
          revert_shipping: 'Revert shipping',
          change_status: 'Change status',
          add_packages: 'Add parcels',
          claimed_trek_ids: 'Claimed Trek IDs',
          search: 'Search',
          status: 'Status',
          cargo_id: 'Cargo ID',
          trek_id: 'Trek ID',
          name: 'Name',
          cargo_id_code: 'Cargo ID code',
          fulfillment_status: 'Fulfillment status',
          region: 'Region',
          created_at: 'Created at',
          splits: 'Splits',
          distribute: 'Distribute/Save',
          support_staff: 'Support staff',
          mark_delivered: 'Mark as delivered',
          arrived_packages: 'Arrived packages',
          arrived_parcels: 'Arrived parcels',
        },
      },
      superNotice: 'This role has all permissions. It cannot be edited.',
      toast: {
        created: 'Role created',
        updated: 'Role updated',
        deleted: 'Role deleted',
      },
    },
    parcelStatus: {
      DRAFT: 'Draft',
      PENDING: 'Pending',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
    },
    fulfillmentStatus: {
      IN_PROGRESS: 'Expected',
      SORTING: 'At warehouse',
      COLLECTING: 'Packaging',
      SHIPPING: 'Shipping',
      ON_THE_WAY: 'On the way',
      ON_CUSTOMS: 'At customs',
      LOCAL_ON_THE_WAY: 'Arrived at warehouse',
      SHIPMENT_ON_CUSTOMERS: 'Delivered',
      WAITING: 'Waiting',
      CONFIRMED: 'Confirmed',
      PACKAGED: 'Packaged',
    },
    warehouseStatus: {
      UNCLAIMED: 'Active',
      LINKED: 'Inactive',
    },
    partyStatus: {
      COLLECTING: 'Packaging',
      SHIPPING: 'Shipping',
      ON_THE_WAY: 'On the way',
      ON_CUSTOMS: 'At customs',
      LOCAL_ON_THE_WAY: 'Arrived at warehouse',
      SHIPMENT_ON_CUSTOMERS: 'Delivered',
    },
    cargoIdType: {
      PHYSICAL: 'Physical',
      LEGAL: 'Legal',
    },
    cargoIds: {
      list: {
        title: 'Cargo ID',
        subtitle: 'Manage Cargo IDs',
        searchPlaceholder: 'Search by code, name or phone',
        loadError: 'Failed to load Cargo IDs',
        emptyTitle: 'No Cargo IDs found',
        emptyDescription: 'Adjust the filter conditions.',
        columns: {
          code: 'Code',
          type: 'Type',
          fullName: 'Full name',
          phone: 'Phone',
          parcelsCount: 'Parcels',
          createdAt: 'Created',
          debt: 'Debt',
          actions: 'Actions',
        },
        actions: {
          view: 'View',
        },
      },
      detail: {
        subtitle: 'Cargo ID details',
        notFound: 'Cargo ID not found',
        noCode: 'No code assigned',
        empty: 'No data',
        fields: {
          fullName: 'Full name',
          phone: 'Phone',
          region: 'Region',
          type: 'Type',
          createdAt: 'Created',
        },
        owner: {
          title: 'Owner',
          fullName: 'Full name',
          phone: 'Phone',
          passport: 'Passport',
          pinfl: 'PINFL',
          openClient: 'Open client profile',
          empty: 'No owner linked',
        },
        parcels: {
          title: 'Parcels',
          loadError: 'Failed to load parcels',
          emptyTitle: 'No parcels',
          view: 'View',
          columns: {
            name: 'Name',
            trekId: 'Trek ID',
            status: 'Status',
            total: 'Total',
            createdAt: 'Date',
            actions: 'Actions',
          },
        },
        charges: {
          title: 'Debt',
          statusPaid: 'Paid',
          statusUnpaid: 'Unpaid',
          statusFree: 'Free',
          markPaid: 'Mark paid',
          markUnpaid: 'Mark unpaid',
          markPaidTitle: 'Confirm payment',
          markPaidDescription: 'Mark the «{{type}}» charge — {{amount}} as paid?',
          markPaidConfirm: 'Yes, paid',
          markPaidToast: 'Charge marked as paid',
          markUnpaidToast: 'Marked as unpaid',
          paidSuccessTitle: 'Successfully paid',
          paidSuccessBody: 'Payment received and a receipt was generated.',
          viewReceipt: 'View receipt',
          emptyTitle: 'No charges',
          loadError: 'Failed to load charges',
          columns: {
            type: 'Type',
            description: 'Description',
            amount: 'Amount',
            status: 'Status',
            actions: 'Actions',
          },
        },
      },
    },
    parties: {
      list: {
        title: 'Parties',
        subtitle: 'Cargo delivery parties',
        newParty: 'New party',
        searchPlaceholder: 'Search by party name',
        loadError: 'Failed to load parties',
        emptyTitle: 'No parties yet',
        emptyDescription: 'Create a new party or adjust the filter conditions.',
        columns: {
          name: 'Name',
          status: 'Status',
          packages: 'Packages',
          createdAt: 'Created',
          actions: 'Actions',
        },
        actions: {
          view: 'View',
          changeStatus: 'Change status',
          delete: 'Delete',
          addPackage: 'Add package',
        },
      },
      detail: {
        subtitle: 'Party details',
        changeStatus: 'Change status',
        manifest: 'Download manifest',
        manifestDownloading: 'Downloading…',
        manifestError: 'Failed to download the manifest.',
        notFound: 'Party not found',
        createdAt: 'Created: {{date}}',
        packagesCount: 'Packages count:',
        addPackage: 'Add package',
        packagesTitle: 'Packages',
        packagesEmptyTitle: 'No packages attached',
        packagesEmptyDescription: 'Use the "Add package" button to attach packages.',
        packagesColumns: {
          name: 'Name',
          parcelsCount: 'Parcels',
          weight: 'Weight',
          createdAt: 'Created',
        },
      },
      addPackage: {
        title: 'Add package',
        description: 'Attach packages to the "{{name}}" party.',
        searchPlaceholder: 'Search by package name',
        selectedCount: 'Selected: {{count}}',
        submit: 'Save',
        emptyTitle: 'No matching packages',
        emptyDescription: 'Only unattached packages or packages in this party are shown.',
        skippedTitle: 'Some packages were skipped:',
        inThisParty: 'In this party',
        bulk: {
          selectPage: 'Select all (this page)',
          unselectPage: 'Unselect this page',
          clear: 'Clear',
          revert: 'Discard unsaved',
        },
        columns: {
          name: 'Name',
          parcelsCount: 'Parcels',
          weight: 'Weight',
          createdAt: 'Created',
        },
        skipReason: {
          not_found: 'Not found',
          already_in_party: 'Already in this party',
          in_other_party: 'In another party',
        },
        toast: {
          added: 'Added {{count}} packages',
          summary: 'Added: {{added}}, Removed: {{removed}}, Skipped: {{skipped}}',
          noChanges: 'No changes',
          removeErrors: 'Remove errors: {{count}}',
        },
      },
      addPackageInline: {
        title: 'Add package',
        subtitle: 'Select the packages you need and press the "Save" button below.',
        addRow: 'Add',
        selected: 'Selected',
        save: 'Save',
        selectedCount: 'Selected: {{count}}',
        emptyTitle: 'No matching packages found',
        emptyDescription: 'Only packages not assigned to any party are shown.',
        parcelsCount: 'Parcels: {{count}}',
        toast: {
          added: 'Package "{{name}}" assigned',
          bulkAdded: '{{count}} packages assigned',
          bulkSkipped: '{{count}} skipped: {{reason}}',
        },
      },
      create: {
        title: 'New party',
        description: 'Give the party a name. The status can be changed later.',
        submit: 'Create',
      },
      status: {
        title: 'Change party status',
        description: 'Pick a new status for the "{{name}}" party. The change will send notifications to users.',
        statusLabel: 'Status',
        statusPlaceholder: 'Select a status',
      },
      form: {
        nameLabel: 'Party name',
        namePlaceholder: 'October-2025',
        errors: {
          nameMin: 'Name must be at least 2 characters',
          tooLong: 'Too long',
        },
      },
      delete: {
        button: 'Delete party',
        title: 'Delete party?',
        description: 'Deleting "{{name}}" will revert its parcels back to the "Sorting" state. This action cannot be undone.',
        confirm: 'Yes, delete',
        toast: 'Party deleted',
      },
      toast: {
        created: 'Party created',
        statusChanged: 'Status changed',
      },
    },
    parcels: {
      list: {
        title: 'Parcels',
        subtitle: 'Manage all parcels',
        newParcel: 'New parcel',
        searchPlaceholder: 'Search by Trek ID or name',
        allStatuses: 'All statuses',
        emptyTitle: 'No parcels found',
        emptyDescription: 'Adjust filters or create a new parcel.',
        loadError: 'Failed to load parcels',
        columns: {
          trekId: 'Trek ID',
          cargoId: 'Cargo ID',
          name: 'Name',
          fulfillment: 'Fulfillment',
          split: 'Split',
          pinfl: 'PINFL',
          total: 'Total',
          date: 'Date',
          hasDebt: 'Debt',
          actions: 'Actions',
        },
        splitBadge: 'Split parcel',
        notSplitBadge: 'Not split parcel',
        debtor: 'Debtor',
        noDebt: 'No debt',
        debtFilterAll: 'All',
        delivered: 'Delivered',
        deliveredToCustomer: 'Delivered to customer',
        actions: {
          view: 'View',
          approve: 'Approve',
          reject: 'Reject',
          edit: 'Edit',
          delete: 'Delete',
        },
      },
      detail: {
        trek: 'Trek: {{trekId}}',
        approve: 'Approve',
        reject: 'Reject',
        edit: 'Edit',
        delete: 'Delete',
        notFound: 'Parcel not found',
        rejectReasonLabel: 'Rejection reason:',
        sections: {
          address: 'Address',
          recipient: 'Recipient',
          cargoId: 'Cargo ID',
          products: 'Products ({{count}})',
        },
        address: {
          name: 'Address name',
          region: 'Region',
          city: 'City',
          street: 'Street',
          info: 'Note',
        },
        recipient: {
          fullName: 'Full name',
          phone: 'Phone',
          passport: 'Passport',
          pinfl: 'PINFL',
          store: 'Store',
        },
        cargoId: {
          code: 'Cargo ID code',
          fullName: 'Full name',
          phone: 'Phone',
          empty: 'No Cargo ID linked',
        },
        products: {
          empty: 'No products added',
          name: 'Product',
          quantity: 'Quantity',
          unitPrice: 'Unit price',
          total: 'Total',
          grandTotal: 'Total',
        },
        charges: {
          title: 'Payments',
          empty: 'No payments',
        },
      },
      create: {
        title: 'New parcel',
        subtitle: 'Created by admin',
        cancel: 'Cancel',
        save: 'Save',
      },
      approve: {
        title: 'Approve parcel',
        duplicatesTitle: 'Warning — duplicates found',
        confirmDescription: 'Approve parcel "{{name}}"? PINFL limit will be checked automatically.',
        duplicatesDescription:
          'There are {{count}} more DRAFT/PENDING parcels with this Trek ID. Approving will automatically delete all of them. Continue?',
        cancel: 'Cancel',
        confirm: 'Approve',
        continue: 'Yes, continue',
        trekId: 'Trek ID:',
        pinfl: 'PINFL:',
        totalAmount: 'Total amount:',
      },
      reject: {
        title: 'Reject parcel',
        description: 'Reject parcel "{{name}}"?',
        cancel: 'Cancel',
        confirm: 'Reject',
        reasonLabel: 'Reason (optional)',
        reasonPlaceholder: 'Comment visible to the user',
      },
      form: {
        sections: {
          cargoId: 'Cargo ID',
          basic: 'Basic information',
          address: 'Delivery address',
          personal: 'Recipient and PINFL',
          confirmShipping: 'Confirm shipping',
          addToWarehouse: 'Add to warehouse',
        },
        confirmShipping: {
          label: 'Confirmed for shipping',
          hint: 'Tick to move the parcel straight to "Sorting".',
          checking: 'Checking warehouse…',
          disabled: {
            emptyTrekId: 'Enter Trek ID',
            notInWarehouse: 'Parcel not found in warehouse',
            inPackage: 'Parcel is attached to a package',
          },
        },
        addToWarehouse: {
          label: 'Add to warehouse',
          hint: 'When ticked the parcel is also added to the warehouse under this Trek ID on create.',
          checking: 'Checking warehouse…',
          disabled: {
            emptyTrekId: 'Enter Trek ID',
            alreadyInWarehouse: 'Trek ID is already in the warehouse',
          },
        },
        cargoId: {
          code: 'Cargo ID code',
          codePlaceholder: 'Enter the exact Cargo ID code',
          searchHint: 'Or search by name or phone',
          searchPlaceholder: 'Search…',
          noResults: 'Nothing found',
          notFound: 'Cargo ID not found',
          fullName: 'Full name',
          phone: 'Phone',
        },
        fields: {
          name: 'Parcel name',
          trekId: 'Trek ID',
          storeName: 'Store name (optional)',
          addressName: 'Address name',
          region: 'Region',
          city: 'City',
          street: 'Street',
          building: 'Building number',
          apartment: 'Apartment (optional)',
          additionalInfo: 'Additional instructions',
          lastName: 'Last name',
          firstName: 'First name',
          middleName: 'Middle name',
          phone: 'Phone',
          passport: 'Passport series',
          pinfl: 'PINFL',
        },
        pinfl: {
          checking: 'Checking limit…',
          usage: 'Limit: {{used}} / {{total}}',
        },
        errors: {
          cargoIdRequired: 'Cargo ID is required',
          nameRequired: 'Parcel name is required',
          tooLong: 'Too long',
          trekIdTooShort: 'Trek ID must be at least 5 characters',
          trekIdLength: 'Trek ID must be 5–255 characters',
          trekIdInvalid: 'Only latin letters, digits, hyphen',
          addressNameRequired: 'Address name is required',
          cityRequired: 'City is required',
          streetRequired: 'Street is required',
          buildingRequired: 'Building number is required',
          firstNameRequired: 'First name is required',
          lastNameRequired: 'Last name is required',
          middleNameRequired: 'Middle name is required',
          phoneTooShort: 'Phone is too short',
          phoneInvalid: 'Invalid phone format',
          passportRequired: 'Passport series is required',
          passportInvalid: '2 uppercase Latin letters and 7 digits, 9 characters total',
          pinflLength: 'PINFL must be {{length}} digits',
          pinflDigitsOnly: 'Digits only',
          confirmRequiresProducts: 'Add at least one product to confirm shipping',
        },
      },
      toast: {
        created: 'Parcel created',
        approved: 'Parcel approved',
        rejected: 'Parcel rejected',
      },
      edit: {
        title: 'Edit parcel',
        subtitle: 'Editing parcel "{{name}}"',
        cancel: 'Cancel',
        save: 'Save',
        toast: {
          updated: 'Parcel updated',
        },
      },
      delete: {
        title: 'Delete parcel',
        description: 'Delete parcel "{{name}}"? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
        toast: {
          deleted: 'Parcel deleted',
        },
      },
      workflowStatus: {
        title: 'Parcel status',
        cancelHint: 'Cancelling reverts the parcel to "In progress" so the client can edit it again. This is only available while in "Sorting" — past that, even admins cannot reset it.',
        cancelAction: 'Cancel parcel',
        confirmTitle: 'Cancel this parcel?',
        confirmDescription: 'The parcel will return to "In progress" and the client will be able to edit it again.',
        confirmAction: 'Yes, cancel',
        toast: {
          reverted: 'Parcel reverted to "In progress"',
        },
      },
      products: {
        title: 'Products ({{count}})',
        add: 'Add product',
        edit: 'Edit',
        delete: 'Delete',
        empty: 'No products added',
        grandTotal: 'Total',
        inlineRow: 'Product #{{index}}',
        columns: {
          name: 'Product',
          quantity: 'Qty',
          unitPrice: 'Unit price',
          total: 'Total',
          actions: 'Actions',
        },
        form: {
          addTitle: 'Add product',
          editTitle: 'Edit product',
          category: 'Category',
          categoryPlaceholder: 'Select category',
          subcategory: 'Subcategory',
          subcategoryPlaceholder: 'Select subcategory',
          fullName: 'Full name',
          quantity: 'Quantity',
          pricePerItem: 'Unit price (USD)',
          cancel: 'Cancel',
          save: 'Save',
        },
        confirmDelete: {
          title: 'Delete product',
          description: 'Delete product "{{name}}"?',
          cancel: 'Cancel',
          confirm: 'Delete',
        },
        toast: {
          added: 'Product added',
          updated: 'Product updated',
          deleted: 'Product deleted',
          partialFailure: 'Products not saved: {{count}}',
          fixRows: 'Fix the errors in the product rows',
        },
        errors: {
          categoryRequired: 'Select a category',
          subcategoryRequired: 'Select a subcategory',
          fullNameRequired: 'Name is required',
          tooLong: 'Too long',
          quantityInvalid: 'Invalid quantity',
          quantityMin: 'Minimum 1',
          priceInvalid: 'Invalid price',
          priceMin: 'Price must be greater than 0',
        },
      },
    },
    warehouse: {
      title: 'Warehouse',
      tabs: {
        owned: 'Parcels with owner',
        orphan: 'Ownerless parcels',
      },
      owned: {
        searchPlaceholder: 'Search by Trek ID or name',
        emptyTitle: 'No parcels found',
        emptyDescription: 'Change the filters.',
        loadError: 'Failed to load parcels',
        columns: {
          trekId: 'Trek ID',
          name: 'Name',
          owner: 'Owner',
          fulfillment: 'Status',
          date: 'Date',
        },
      },
      list: {
        title: 'Warehouse',
        subtitle: 'Manage ownerless parcels',
        newProduct: 'Add',
        scan: 'Scan',
        searchPlaceholder: 'Search by Trek ID or name',
        allStatuses: 'All statuses',
        emptyTitle: 'No parcels found',
        emptyDescription: 'Change the filters or add an ownerless parcel.',
        loadError: 'Failed to load parcels',
        columns: {
          trekId: 'Trek ID',
          name: 'Name',
          region: 'Region',
          status: 'Status',
          linkedParcel: 'Linked parcel',
          date: 'Date',
          actions: 'Actions',
        },
      },
      form: {
        createTitle: 'Ownerless parcel',
        editTitle: 'Edit ownerless parcel',
        description: 'Only Trek ID is required, the rest are optional.',
        kg: 'kg',
        fields: {
          trekId: 'Trek ID',
          name: 'Name',
          quantity: 'Quantity',
          price: 'Price',
          weight: 'Weight',
          note: 'Note',
          storeName: 'Store name',
          storeNamePlaceholder: 'Amazon, AliExpress, ...',
          cargoIdCode: 'Cargo ID code',
          cargoIdCodePlaceholder: 'T10001',
          address: 'Address',
          addressPlaceholder: 'Delivery address',
        },
        fio: {
          label: 'Full name',
          loading: 'Searching…',
          notFound: 'Not found',
          empty: 'Enter a Cargo ID code',
        },
        errors: {
          trekIdRequired: 'Trek ID is required',
          tooLong: 'Too long',
          invalidNumber: 'Invalid value',
          cargoIdNotFound: 'Cargo ID code not found',
        },
      },
      formPage: {
        createTitle: 'Add ownerless parcel',
        editTitle: 'Edit ownerless parcel',
        notFound: 'Parcel not found',
        loadError: 'Failed to load parcel',
      },
      scanner: {
        title: 'Scan',
        titleOnly: 'Scan Trek ID',
        close: 'Close',
        toast: {
          added: '{{trekId}} added',
          duplicate: '{{trekId}} already added',
          wait: 'Please wait',
        },
      },
      delete: {
        title: 'Delete parcel',
        description: 'Delete parcel {{trekId}}?',
        confirm: 'Delete',
        toast: {
          deleted: 'Parcel deleted',
        },
      },
      toast: {
        created: 'Parcel added',
        updated: 'Parcel updated',
        duplicateTrekId: 'An ownerless product with this trek ID already exists',
      },
    },
    warehouseArrivals: {
      tabs: { packages: 'Arrived packages', parcels: 'Arrived parcels' },
      packages: {
        searchPlaceholder: 'Search by name or ID',
        scan: 'Scan',
        view: 'View',
        deliveredToCustomer: 'Delivered to customer',
        delivered: { yes: 'Yes', no: 'No' },
        emptyTitle: 'No packages found',
        emptyDescription: 'Try adjusting your filters.',
        loadError: 'Failed to load packages',
        columns: { name: 'Name', uniqueId: 'Unique ID', party: 'Party', parcels: 'Parcels', delivered: 'Delivered to customer', actions: 'Actions' },
        toast: { delivered: 'Status updated' },
        confirm: {
          markTitle: 'Mark as delivered to customer',
          markDescription: 'Mark this package as delivered to the customer?',
          markConfirm: 'Yes, delivered',
          cancelTitle: 'Cancel delivery',
          cancelDescription: 'Cancel the "delivered" status for this package?',
          cancelConfirm: 'Yes, cancel',
          dismiss: 'Close',
        },
        viewTitle: 'Package details',
        notFound: 'Package not found',
        loadDetailError: 'Failed to load package',
        fields: { name: 'Name', uniqueId: 'Unique ID', party: 'Party', price: 'Price', weight: 'Weight', parcels: 'Parcels' },
      },
      parcels: {
        searchPlaceholder: 'Search by trek ID or name',
        view: 'View',
        emptyTitle: 'No parcels found',
        emptyDescription: 'Try adjusting your filters.',
        loadError: 'Failed to load parcels',
        delivered: { yes: 'Yes', no: 'No' },
        columns: { name: 'Name', trekId: 'Trek ID', pinfl: 'PINFL', delivered: 'Delivered to customer', split: 'Split', actions: 'Actions' },
        viewTitle: 'Parcel details',
        notFound: 'Parcel not found',
        loadDetailError: 'Failed to load parcel',
        fields: { name: 'Name', trekId: 'Trek ID', pinfl: 'PINFL', delivered: 'Delivered to customer', split: 'Split' },
      },
      scan: {
        title: 'Scan',
        placeholder: 'Scan or enter unique ID',
        submit: 'Confirm',
        close: 'Close',
        notArrived: 'This package has not arrived yet',
        notFound: 'Package not found',
        scanning: 'Scanning...',
      },
    },
    packages: {
      list: {
        title: 'Packages',
        subtitle: 'Manage packages',
        newPackage: 'New package',
        searchPlaceholder: 'Search by name',
        emptyTitle: 'No packages found',
        emptyDescription: 'Create a new package or change the filter.',
        loadError: 'Failed to load packages',
        columns: {
          name: 'Name',
          price: 'Price',
          weight: 'Weight',
          parcelsCount: 'Parcels',
          createdAt: 'Date',
          actions: 'Actions',
        },
      },
      form: {
        createTitle: 'New package',
        editTitle: 'Edit package',
        notFound: 'Package not found',
        loadError: 'Failed to load package',
        fields: {
          name: 'Name',
          uniqueId: 'Unique ID',
          price: 'Price',
          weight: 'Weight',
          weightUnit: 'Weight unit',
        },
        generate: 'Generate',
        downloadQr: 'Download QR',
        weightUnit: {
          kg: 'kg',
          g: 'g',
        },
        errors: {
          nameRequired: 'Name is required',
          invalidNumber: 'Invalid number',
          tooLong: 'Too long',
          parcelsRequired: 'Add at least one parcel',
        },
      },
      columns: {
        productName: 'Product name',
        quantity: 'Quantity',
        unitPrice: 'Unit price',
        totalPrice: 'Total price',
        trekId: 'Trek ID',
        cargoId: 'Cargo ID',
        passport: 'Passport',
        pinfl: 'PINFL',
        date: 'Date',
        actions: 'Actions',
        parcelName: 'Parcel name',
        products: 'Products',
      },
      parcelPicker: {
        title: 'Parcels',
        subtitle: 'Attached parcels: {{count}}',
        addBtn: 'Add parcel',
        emptyAttached: 'No parcels attached yet',
        selectedEmpty: 'No parcels selected',
        filters: {
          trekId: 'Search by Trek ID',
          name: 'Search by product name',
          cargoId: 'Search by Cargo ID',
        },
        dialog: {
          title: 'Add parcel',
          searchPlaceholder: 'Search by Trek ID / product / Cargo ID',
          emptyTitle: 'No matching parcels',
          emptyDescription: 'Try a different query.',
          loadError: 'Failed to load parcels',
          addRow: 'Add',
          alreadyAdded: 'Added',
          productSingle: '{{name}} × {{qty}}',
          productSummary: '{{name}} × {{qty}} (+{{extra}})',
        },
      },
      delete: {
        title: 'Delete package',
        description: 'Delete package "{{name}}"?',
        confirm: 'Delete',
      },
      toasts: {
        created: 'Package created',
        updated: 'Package updated',
        deleted: 'Package deleted',
      },
    },
    categories: {
      list: {
        title: 'Categories',
        subtitle: 'Product categories and subcategories',
        newCategory: 'New category',
        loadError: 'Failed to load categories',
        emptyTitle: 'No categories yet',
        emptyDescription: 'Create a new category and add subcategories to it.',
        subcategoriesCount: '{{count}} sub',
        emptySubcategories: 'No subcategories yet',
        expand: 'Expand',
        collapse: 'Collapse',
        addSubcategory: 'Add subcategory',
      },
      form: {
        createTitle: 'New category',
        editTitle: 'Edit category',
        description: 'Enter the category name in 3 languages.',
        nameUz: 'Name (UZ)',
        nameRu: 'Name (RU)',
        nameEn: 'Name (EN)',
        nameKk: 'Name (KK)',
        errors: {
          nameUzRequired: 'Uzbek name is required',
          nameRuRequired: 'Russian name is required',
          nameEnRequired: 'English name is required',
          tooLong: 'Too long',
        },
      },
      subcategory: {
        createTitle: 'New subcategory',
        editTitle: 'Edit subcategory',
      },
      confirmDelete: {
        title: 'Delete category',
        description: 'Category "{{name}}" will be deleted along with all its subcategories.',
        confirm: 'Delete',
      },
      confirmDeleteSub: {
        title: 'Delete subcategory',
        description: 'Delete "{{name}}"?',
        confirm: 'Delete',
      },
      toast: {
        created: 'Category created',
        updated: 'Category updated',
        deleted: 'Category deleted',
        subCreated: 'Subcategory added',
        subUpdated: 'Subcategory updated',
        subDeleted: 'Subcategory deleted',
      },
      reassign: {
        title: 'Move products',
        catDescription:
          'The «{{name}}» category is used by products. Move the products to another category before deleting.',
        subDescription:
          'The «{{name}}» subcategory is used by products. Move the products to another subcategory before deleting.',
        catLabel: 'New category',
        subLabel: 'New subcategory',
        placeholder: 'Select',
        confirm: 'Move and delete',
        catNoTargets: 'No other category to move to. Create a category first.',
        subNoTargets: 'No other subcategory to move to. Create a subcategory first.',
      },
    },
    staff: {
      list: {
        title: 'Staff',
        subtitle: 'Users with system access',
        newStaff: 'New staff member',
        searchPlaceholder: 'By name, username or phone',
        loadError: 'Failed to load staff',
        emptyTitle: 'No staff yet',
        active: 'Active',
        inactive: 'Inactive',
        activate: 'Activate',
        deactivate: 'Deactivate',
        superBadge: 'Super staff',
        columns: {
          fullName: 'Full name',
          username: 'Username',
          phone: 'Phone',
          role: 'Role',
          status: 'Status',
          createdAt: 'Created',
          actions: 'Actions',
        },
      },
      formPage: {
        createTitle: 'New staff member',
        editTitle: 'Edit staff member',
        notFound: 'Staff member not found.',
        loadError: 'Failed to load staff member',
        superNote: 'This is a super staff member — no role can be assigned',
      },
      form: {
        title: 'New staff member',
        description: 'Create a staff account. The password is shown only once — save it.',
        submit: 'Create',
        fields: {
          fullName: 'Full name',
          username: 'Username',
          password: 'Password',
          passwordOptional: 'New password (optional)',
          passwordEditPlaceholder: 'Leave empty to keep current',
          phone: 'Phone (optional)',
          phonePlaceholder: '+998901234567',
          role: 'Role',
          rolePlaceholder: 'Select a role',
        },
        errors: {
          fullNameRequired: 'Full name is required',
          usernameMin: 'Username must be at least 3 characters',
          usernameInvalid: 'Only latin letters, digits, _ . -',
          passwordMin: 'Password must be at least 6 characters',
          tooLong: 'Too long',
          roleRequired: 'Role is required',
          rolesLoadFailed: 'Failed to load roles',
        },
      },
      confirmDelete: {
        title: 'Delete staff member',
        description: 'Account "{{name}}" will be permanently deleted.',
        confirm: 'Delete',
      },
      confirmToggle: {
        deactivate: {
          title: 'Deactivate staff member',
          description: 'Account "{{name}}" will be deactivated — the staff member won\'t be able to sign in. Continue?',
          confirm: 'Yes, deactivate',
        },
        activate: {
          title: 'Activate staff member',
          description: 'Account "{{name}}" will be re-activated and the staff member will be able to sign in.',
          confirm: 'Yes, activate',
        },
      },
      toast: {
        created: 'Staff member created',
        updated: 'Staff member updated',
        deleted: 'Staff member deleted',
        activated: 'Staff member activated',
        deactivated: 'Staff member deactivated',
      },
    },
    supportStaff: {
      list: {
        title: 'Support staff',
        subtitle: 'Specialists who help customers',
        emptyTitle: 'No support staff yet',
        loadError: 'Failed to load support staff',
        yearsSuffix: '{{count}} years',
        create: 'New support staff',
        columns: {
          image: 'Photo',
          name: 'Name',
          contact: 'Contact link',
          languages: 'Languages',
          experience: 'Experience (years)',
          createdAt: 'Created',
          actions: 'Actions',
        },
      },
      form: {
        createTitle: 'New support staff',
        editTitle: 'Edit support staff',
        description: 'Enter the support staff details.',
        fields: {
          name: 'Name',
          contact: 'Contact link',
          languages: 'Languages',
          experience: 'Experience (years)',
          image: 'Photo',
          pickImage: 'Pick image',
          languagesPlaceholder: 'Type a language and add',
          addLanguage: 'Add',
        },
        errors: {
          nameRequired: 'Name is required',
          tooLong: 'Too long',
          contactRequired: 'Contact link is required',
          contactInvalid: 'Invalid link',
          languagesRequired: 'Add at least one language',
          experienceMin: 'Experience cannot be less than 0',
          imageType: 'Only image files allowed',
          imageTooLarge: 'Image is too large',
        },
        notFound: 'Support staff not found',
      },
      toast: {
        created: 'Support staff created',
        updated: 'Support staff updated',
        deleted: 'Support staff deleted',
      },
      confirmDelete: {
        title: 'Delete support staff',
        description: 'Delete "{{name}}"?',
        confirm: 'Delete',
      },
    },
    faqs: {
      list: {
        title: 'FAQ',
        subtitle: 'Frequently asked questions for clients',
        newFaq: 'New question',
        loadError: 'Failed to load FAQs',
        emptyTitle: 'No questions yet',
        emptyDescription: 'Add the first question.',
        active: 'Active',
        inactive: 'Inactive',
        activate: 'Activate',
        deactivate: 'Deactivate',
      },
      form: {
        createTitle: 'New question',
        editTitle: 'Edit question',
        description: 'Enter the question and answer in 3 languages.',
        questionUz: 'Question (UZ)',
        questionRu: 'Question (RU)',
        questionEn: 'Question (EN)',
        questionKk: 'Question (KK)',
        answerUz: 'Answer (UZ)',
        answerRu: 'Answer (RU)',
        answerEn: 'Answer (EN)',
        answerKk: 'Answer (KK)',
        order: 'Order',
        isActive: 'Active',
        errors: {
          required: 'Required field',
          tooLong: 'Too long',
          order: 'Order must be at least 0',
        },
      },
      confirmDelete: {
        title: 'Delete question',
        description: 'Delete "{{name}}"?',
        confirm: 'Delete',
      },
      confirmToggle: {
        activateTitle: 'Activate question',
        activateDescription: 'Activate "{{name}}"?',
        activateConfirm: 'Activate',
        deactivateTitle: 'Deactivate question',
        deactivateDescription: 'Deactivate "{{name}}"?',
        deactivateConfirm: 'Deactivate',
      },
      toast: {
        created: 'Question added',
        updated: 'Question updated',
        deleted: 'Question deleted',
        activated: 'Question activated',
        deactivated: 'Question deactivated',
      },
    },
    support: {
      list: {
        title: 'Support',
        subtitle: 'Conversations with clients',
        searchPlaceholder: 'By email or name',
        loadError: 'Failed to load conversations',
        emptyTitle: 'No conversations yet',
        emptyDescription: 'Client messages will appear here.',
        blocked: 'Blocked',
      },
      chat: {
        title: 'Conversation',
        loadError: 'Failed to load conversation',
        emptyTitle: 'No messages',
        emptyDescription: 'Send the first message.',
        messagePlaceholder: 'Type a message…',
        send: 'Send',
        attach: 'Attach file',
        file: 'File',
        fileTooLarge: 'File size must not exceed 10MB',
        block: 'Block',
        unblock: 'Unblock',
        blockedState: 'Blocked',
        confirmBlock: {
          title: 'Block client',
          description: '"{{name}}" will be blocked and unable to message you. Continue?',
          confirm: 'Yes, block',
        },
        toast: {
          blocked: 'Client blocked',
          unblocked: 'Client unblocked',
        },
        info: {
          email: 'Email',
          name: 'Name',
          phone: 'Phone',
          address: 'Address',
          zip: 'ZIP code',
          languages: 'Languages',
        },
      },
    },
    limitConfig: {
      title: 'PINFL limit settings',
      subtitle: "Manage clients' spending limit and its renewal period",
      loadError: 'Failed to load settings',
      updatedAt: 'Last updated: {{date}}',
      form: {
        amountSection: 'Limit amount',
        cadenceSection: 'Renewal period',
        cadenceDescription: 'The limit resets every N days or every N months',
        resetSection: 'Current usage',
        submit: 'Save',
        periodUnit: {
          DAY: 'Days',
          MONTH: 'Months',
        },
        fields: {
          amount: 'Limit amount (USD)',
          periodUnit: 'Period unit',
          periodValueDay: 'Every how many days',
          periodValueMonth: 'Every how many months',
          startDay: 'Renewal day of month',
          startDate: 'Start date',
          timezone: 'Timezone',
          resetUsage: "Reset clients' usage when changing the limit",
        },
        hints: {
          amount: 'The ceiling each client can spend within a period.',
          startDay: 'If the day is 29–31 and the month is shorter (e.g. February), the renewal rolls over to the 1st of the next month.',
          startDate: 'The daily period is counted from this date.',
          resetUsageOn: "All clients' used amounts will be reset to 0.",
          resetUsageOff: 'Clients keep their current usage. If the new amount is lower, some clients may end up over the limit.',
        },
        errors: {
          amountInvalid: 'Invalid value',
          amountMin: 'Cannot be negative',
          periodValueInvalid: 'Enter a whole number',
          periodValueMin: 'At least 1',
          startDayInvalid: 'Enter a whole number',
          startDayRange: 'Day must be between 1 and 31',
          timezoneRequired: 'Select a timezone',
        },
      },
      toast: {
        saved: 'Limit settings saved',
      },
    },
    pricing: {
      title: 'Prices',
      subtitle: 'Limit and service prices',
      loadError: 'Failed to load prices',
      limitSection: 'Limit settings',
      pricingSection: 'Service prices',
      fields: {
        limit: 'Limit',
        splitFee: 'Split fee',
        packagePricePerKg: 'Package price (kg)',
        photoFee: 'Photo fee',
        videoFee: 'Video fee',
        proverkaFee: 'Inspection fee',
        returnFee: 'Return fee',
      },
      toast: {
        savedLimit: 'Limit saved',
        savedPricing: 'Prices saved',
      },
      save: 'Save',
    },
    serviceReports: {
      photo: {
        title: 'Photo reports',
        subtitle: 'Customer photo requests',
      },
      video: {
        title: 'Video reports',
        subtitle: 'Customer video requests',
      },
      proverka: {
        title: 'Inspection reports',
        subtitle: 'Customer inspection requests',
      },
      columns: {
        parcel: 'Parcel',
        contact: 'Contact',
        note: 'Note',
        fee: 'Fee',
        status: 'Status',
        createdAt: 'Date',
        actions: 'Action',
      },
      filter: {
        all: 'All',
        pending: 'Pending',
        done: 'Done',
      },
      markDone: 'Sent',
      cancel: 'Cancel',
      cancelTitle: 'Cancel request',
      cancelDescription: 'Cancel this request for parcel “{{name}}”? The charged fee will also be reversed and the client can submit a new request.',
      cancelConfirm: 'Yes, cancel',
      markDoneTitle: 'Mark as sent',
      markDoneDescription: 'Mark this request for parcel “{{name}}” as sent to the client?',
      markDoneConfirm: 'Yes, sent',
      emptyTitle: 'No reports',
      emptyDescription: 'No requests yet',
      loadError: 'Failed to load reports',
      status: {
        cancelled: 'Cancelled',
      },
      toast: {
        done: 'Marked as sent',
        cancelled: 'Cancelled',
      },
    },
    returns: {
      title: 'Returns',
      subtitle: 'Customer return requests',
      columns: {
        parcel: 'Parcel',
        note: 'Note',
        fee: 'Fee',
        status: 'Status',
        createdAt: 'Date',
        actions: 'Action',
      },
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      confirm: 'Confirm',
      reject: 'Reject',
      cancel: 'Cancel',
      confirmTitle: 'Confirm return',
      confirmDescription: 'Confirm this return request for parcel “{{name}}”?',
      confirmConfirm: 'Yes, confirm',
      rejectTitle: 'Reject return',
      rejectDescription: 'Reject this return request for parcel “{{name}}”?',
      rejectReasonLabel: 'Rejection reason',
      rejectReasonPlaceholder: 'Enter a reason (optional)',
      rejectConfirm: 'Yes, reject',
      cancelTitle: 'Cancel return',
      cancelDescription: 'Cancel this return request for parcel “{{name}}”? The charged fee will also be reversed and the client can submit a new request.',
      cancelConfirm: 'Yes, cancel',
      filter: {
        all: 'All',
        pending: 'Pending',
        confirmed: 'Confirmed',
        rejected: 'Rejected',
      },
      toast: {
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      loadError: 'Failed to load returns',
      emptyTitle: 'No returns',
      emptyDescription: 'No requests yet',
    },
    clients: {
      empty: 'No data',
      list: {
        title: 'Clients',
        subtitle: 'Registered clients',
        searchPlaceholder: 'Search by email or name',
        loadError: 'Failed to load clients',
        emptyTitle: 'No clients yet',
        emptyDescription: 'Adjust the search conditions.',
        columns: {
          email: 'Email',
          fullName: 'Full name',
          phone: 'Phone',
          limit: 'Limit',
          status: 'Status',
          createdAt: 'Joined date',
          actions: 'Actions',
        },
        actions: {
          view: 'View',
        },
        status: {
          active: 'Active',
          blocked: 'Blocked',
        },
      },
      detail: {
        subtitle: 'Client details',
        notFound: 'Client not found',
        infoSection: 'Personal information',
        fields: {
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          phone: 'Phone',
          address: 'Address',
          zip: 'ZIP code',
          languages: 'Languages',
          pinfl: 'PINFL',
          limit: 'Limit',
          createdAt: 'Joined date',
        },
      },
      block: {
        blockButton: 'Block parcel creation',
        unblockButton: 'Unblock',
        blockTitle: 'Block parcel creation',
        blockDescription: 'The client will lose the ability to create parcels. Continue?',
        unblockTitle: 'Unblock',
        unblockDescription: 'The client will regain the ability to create parcels. Continue?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        toastBlocked: 'Client is blocked from creating parcels',
        toastUnblocked: 'Client unblocked',
      },
      claimedTrekIds: {
        title: 'Owned Trek IDs',
        columns: {
          trekId: 'Trek ID',
          parcelStatus: 'Parcel status',
          fulfillmentStatus: 'Fulfillment',
          partyStatus: 'Party status',
          cargoIdCode: 'Cargo ID',
          createdAt: 'Date',
        },
        empty: 'No data yet',
        loadError: 'Failed to load Trek IDs',
      },
      receipts: {
        title: 'Payment history',
        columns: {
          number: 'Receipt no.',
          parcel: 'Parcel',
          amount: 'Amount',
          createdAt: 'Date',
          actions: 'Actions',
        },
        view: 'View',
        pdf: 'PDF',
        empty: 'No payments',
        loadError: 'Failed to load payment history',
      },
    },
    broadcast: {
      title: 'Send announcement',
      subtitle: 'Send a notification to all clients',
      form: {
        textSection: 'Announcement text',
        textHint: 'The text will be sent to all clients as a notification.',
        imageSection: 'Image (optional)',
        imageHint: 'You can attach an image to the announcement (max 10MB).',
        pickImage: 'Pick image',
        submit: 'Send',
        fields: {
          textUz: 'Message (uz)',
          textUzPlaceholder: 'Enter the announcement text…',
          textRu: 'Message (ru)',
          textRuPlaceholder: 'Enter the announcement text in Russian…',
          textEn: 'Message (en)',
          textEnPlaceholder: 'Enter the announcement text in English…',
          textKk: 'Message (kk)',
          textKkPlaceholder: 'Enter the announcement text in Kazakh…',
          textKkHint: 'If left empty, Kazakh-speaking clients will see the Russian text.',
        },
        errors: {
          textRequired: 'Text is required',
          tooLong: 'Too long',
          imageType: 'Image files only',
          imageTooLarge: 'Image size must not exceed 10MB',
        },
      },
      toast: {
        sent: 'Announcement sent to {{count}} clients',
      },
    },
    splits: {
      list: {
        title: 'Splits',
        subtitle: 'Split parcels among recipients',
        searchPlaceholder: 'Search by trek number',
        loadError: 'Failed to load splits',
        emptyTitle: 'No splits found',
        emptyDescription: 'No splits yet',
        columns: {
          trekId: 'Trek',
          parcel: 'Parcel',
          status: 'Status',
          targets: 'Recipients',
          total: 'Total',
          createdAt: 'Created',
          actions: 'Actions',
        },
      },
      status: {
        DRAFT: 'Draft',
        IN_PROGRESS: 'In progress',
        DELIVERED: 'Delivered',
        RESERVED: 'Reserved',
        DISTRIBUTED: 'Distributed',
        CONFIRMED: 'Confirmed',
        CANCELLED: 'Cancelled',
      },
      detail: {
        trek: 'Trek number: {{trek}}',
        notFound: 'Split not found',
        loadError: 'Failed to load split',
        sections: {
          parcel: 'Source parcel',
          targets: 'Recipients',
          allocation: 'Allocation',
        },
        parcel: {
          trekId: 'Trek',
          name: 'Name',
          pinfl: 'PINFL',
          serviceFee: 'Service fee',
          total: 'Total amount',
        },
        target: {
          recipient: 'Recipient',
          pinfl: 'PINFL',
          address: 'Address',
          reserved: 'Reserved',
          total: 'Total',
          package: 'Package',
        },
        allocation: {
          product: 'Product',
          quantity: 'Quantity',
          amount: 'Amount',
          total: 'Total',
          empty: 'No allocations',
        },
        statusNote: {
          CANCELLED: 'This split has been cancelled',
          RESERVED: 'This split is reserved',
        },
      },
      distribute: {
        title: 'Distribute products',
        hint: 'Distribute each product among recipients',
        productHeader: 'Product',
        totalQty: 'Available',
        unitPrice: 'Price',
        remaining: 'Remaining',
        targetTotal: 'Total',
        overLimit: 'Over the limit',
        submit: 'Distribute',
        errors: {
          overAllocated: 'Allocated quantity exceeds available amount',
          pinflLimit: 'PINFL {{pinfl}} limit is insufficient',
        },
        success: 'Distributed',
      },
      confirm: {
        button: 'Confirm',
        confirmTitle: 'Confirm split',
        confirmDescription: 'A package will be created for each recipient. Continue?',
        confirmAction: 'Confirm',
        success: 'Packages created',
      },
      cancel: {
        button: 'Cancel',
        confirmTitle: 'Cancel split',
        confirmDescription: 'The split will be cancelled and reserves returned. Continue?',
        confirmAction: 'Cancel',
        success: 'Split cancelled',
      },
      empty: {
        products: 'No products',
        targets: 'No recipients',
        allocations: 'No allocations',
      },
      save: {
        title: 'Save',
        sections: {
          products: 'Products',
          recipients: 'PINFLs (recipients)',
          serviceFee: 'Service fee',
        },
        product: {
          name: 'Product name',
          quantity: 'Qty',
          unitPrice: 'Price',
        },
        recipient: {
          title: 'Recipient',
          pinfl: 'PINFL',
          firstName: 'First name',
          lastName: 'Last name',
          middleName: 'Middle name',
          phone: 'Phone',
          passport: 'Passport series',
          addressName: 'Address name',
          region: 'Region',
          city: 'City/district',
          street: 'Street',
          building: 'Building',
          apartment: 'Apartment',
          additionalInfo: 'Additional info',
        },
        package: {
          name: 'Package name',
          price: 'Package price',
          priceOptional: 'Package price (optional)',
          priceHint: 'If empty, computed from weight',
          weight: 'Weight',
          weightUnit: 'Weight unit',
          uniqueId: 'Unique ID',
        },
        allocations: {
          title: 'Products',
          product: 'Product',
          quantity: 'Qty',
          addProduct: 'Add product',
          removeProduct: 'Remove',
          selectPlaceholder: 'Select product',
          empty: 'No products',
        },
        limit: {
          label: 'Limit',
          value: '{{used}} / {{ceiling}}',
        },
        addPinfl: 'Add PINFL',
        removePinfl: 'Remove PINFL',
        expand: 'Expand',
        collapse: 'Collapse',
        serviceFeeLabel: 'Service fee',
        generate: 'Generate',
        downloadQr: 'Download QR',
        serviceFeeComputed: 'Total service fee: {{total}} ({{count}} × {{fee}})',
        submit: 'Save',
        delete: 'Delete',
        deleteConfirmTitle: 'Delete split',
        deleteConfirmDescription: 'This split will be permanently deleted. Continue?',
        readOnlyNote: 'This split cannot be edited',
        success: 'Saved',
        deleteSuccess: 'Split deleted',
        errors: {
          exceedsAvailable: 'Exceeds the available quantity',
          saveFailed: 'Failed to save',
          pinflRequired: 'PINFL is required',
          distributionExact: 'These products are not fully allocated: {{products}}',
        },
      },
    },
    },
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'uz',
    supportedLngs: ['uz', 'ru', 'en'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'jc_admin_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
